import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ValidatorService } from '../services/hl7validationfunctions.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forEach } from 'jszip';
import { CommonService } from '../services/common.service';
import { Console } from 'console';
import { SaveAllConfirmationDialogComponent, SaveAllConfirmationDialogData } from './save-all-confirmation-dialog/save-all-confirmation-dialog.component';
import { AddMappingDialogComponent, AddMappingDialogData } from './add-mapping-dialog/add-mapping-dialog.component';
declare const copyToClipboard: any;

@Component({
  selector: 'app-hl7viewer',
  templateUrl: './hl7viewer.component.html',
  styleUrls: ['./hl7viewer.component.scss']
})

export class Hl7viewerComponent implements OnInit {
  VASpec: any;
  noofrows: number = 8;
  currentSegmentLine:any;
  // Interface context properties
  @Input() interfaceId: string = '';
  @Input() processorAgentId: string = '';
  @Input() isFromInterface: boolean = false;
  
  private aliasLookup: Map<string, string> = new Map();
  
  // Mapping modal properties
  showMappingModal: boolean = false;
  currentSubcomponent: any = null;
  currentHl7Path: string = '';
  currentMappings: Array<{ xmlPath: string, condition: string, canEdit?: boolean }> = [];
  availableAliases: Array<{ path: string, alias: string }> = [];
  selectedAliasPath: string = '';
  mappingCondition: string = '';
  editingMappingIndex: number | null = null;
  isAddingMapping: boolean = false;

  // CHANGED: Batch editing - Pending changes tracking
  // REVERT: Remove this section to revert to individual save/delete
  pendingChanges: Map<string, Array<{
    action: 'add' | 'delete' | 'update',
    mapping: { xmlPath: string, condition: string, hl7Path: string },
    originalMapping?: { xmlPath: string, condition: string, hl7Path: string }, // for updates
    id: string // unique ID for this pending change
  }>> = new Map();
  
  showSaveAllConfirmation: boolean = false;

  // Expression functions configuration for expression builder
  expressionFunctionsConfig: any = null;
  private expressionFunctionsLoaded: boolean = false;
  
  // Function config modal properties
  showFunctionConfigModal: boolean = false;
  functionSearchTerm: string = '';
  editingFunctionIndex: number | null = null;
  isAddingFunction: boolean = false;
  editingFunction: any = { name: '', displayName: '', category: 'String', description: '', template: '', parameters: [] };
  hasUnsavedFunctionChanges: boolean = false;

  constructor(private myServices: ValidatorService,
    private activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private ngxUiLoaderService: NgxUiLoaderService,
    private commonService: CommonService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog) {
    this.route.queryParams.subscribe(params => {
      //  this.receivedData = params['data'];
      if (params['fileid'] !== undefined && params !== undefined) {
        this.getfileContentById(params['fileid']);
        this.noofrows = 10;
      }
    });

    // this.Parseinputselecteddata(this.inputdata);
  }
  receivedMessage: string = ''
  splittedContent: any[] = []
  splittedContentWithHighlights: SafeHtml[] = [] // Processed HL7 with HTML spans for highlighting (sanitized)
  fieldvalues: any[] = []
  subcomponentHighlighttext: any
  segmentMappingStatus: Map<string, Map<number, boolean>> = new Map(); // segmentLine -> fieldIndex -> isMapped
  fieldMappingInfo: Map<string, Map<number, Array<{ xmlPath: string, alias: string }>>> = new Map(); // segmentLine -> fieldIndex -> array of mappings
  @Input() inputDataInModalComponent: any;

  async ngOnInit(): Promise<void> {
    // Load alias lookup from CSV
    await this.loadAliasLookup();
    // Load available aliases for dropdown
    await this.loadAvailableAliases();

    this.route.params.subscribe(params => {

      this.receivedMessage = params['message'];
      this.inputdata = this.receivedMessage;
    });
    this.segmentSubcomponentheader = 'Name';
    this.receivedMessage = this.inputDataInModalComponent;
    this.inputdata = this.receivedMessage || '';

    // If no HL7 loaded yet, set default spec and exit early; user will click Load HL7
    if (!this.inputdata || this.inputdata.trim().length === 0) {
      this.VASpec = this.commonService.hl7VASpec;
      return;
    }

    this.splittedContent = (this.inputdata || '').split("\n");
    // Initialize with original content until preprocessing is done (sanitized)
    this.splittedContentWithHighlights = this.splittedContent.map(line => 
      this.sanitizer.bypassSecurityTrustHtml(line)
    );
    if (this.splittedContent.length > 0 && this.splittedContent[0].includes('|') &&
        this.splittedContent[0].split("|").length > 8 && this.splittedContent[0].split("|")[8].includes("BAR")) {
      this.VASpec = this.commonService.BAR;
    }
    else if (this.splittedContent.length > 0 && this.splittedContent[0].includes('|') &&
             this.splittedContent[0].split("|").length > 8 && this.splittedContent[0].split("|")[8].includes("DFT")) {
      this.VASpec = this.commonService.DFT;
    }
    else if (this.splittedContent.length > 0 && this.splittedContent[0].includes('|') &&
             this.splittedContent[0].split("|").length > 8 && this.splittedContent[0].split("|")[8].includes("ORU")) {
      this.VASpec = this.commonService.ORU;
    }
    else {
      this.VASpec = this.commonService.hl7VASpec;
    }



    await this.Parseinputselecteddata(this.inputdata);
    if (this.segmentheader && this.segmentheader !== 'Name') {
      await this.getfieldsbyheaders(this.segmentheader);
    }

    // Load mappings for this HL7
    try {
      if (this.isFromInterface && this.interfaceId && this.processorAgentId) {
        await this.loadMappings(this.inputdata, this.interfaceId, this.processorAgentId);
      } else {
        await this.loadMappings(this.inputdata, 'default', 'default');
      }
    } catch (e) {
      // swallow errors in viewer-only mode
      console.warn('HL7 mappings load failed', e);
    }


  }
  onKeydown(event: any) {
    console.log("inside onKeydown ");
    event.preventDefault();
  }
  onSpace(event: any) {
    console.log("inside onSpace")
    event.preventDefault();
  }

  inputdata: any = '';
  segments: any = [];
  displaynamesegheader: string = 'Name';
  segmentheader: string = 'Name'

  async Parseinputselecteddata(segdata: any) {
    if (!segdata || typeof segdata !== 'string') {
      this.segments = [];
      this.segmentheader = 'Name';
      return;
    }
    // Remember the exact HL7 line the user selected; used for context-aware mapping
    this.currentSegmentLine = segdata;
    this.segments = segdata.split('\n');
    if (this.segments.length > 0) {
      //this.segmentheader = this.segments[0].substr(0, 3);
      if (this.segments[0].includes('|')) {
        this.segmentheader = this.segments[0].split('|')[0];
      }
      else {
        this.segmentheader = 'Name';
      }
    }
  }
  returnvalue: any
  getfieldsbyheaders(segment: any) {

    this.returnvalue = undefined
    this.fieldvalues = []
    let currectSegment = [];
    
    // Get the current segment line
    currectSegment = this.segments.filter((va: string) => va.toUpperCase().includes(segment.toUpperCase()));
    
    if (currectSegment.length === 0) {
      return;
    }

    // Parse all fields from the actual HL7 segment
    let segmentFields = currectSegment[0].split('|');
    
    // Handle MSH segment special case
    // After splitting by '|', MSH fields are already correctly positioned:
    // [0] = "MSH" (segment name), [1] = "^~\&" (MSH-1: Encoding Characters), 
    // [2] = "GMED" (MSH-2: Sending Application), etc.
    // No need to insert the field separator as a field value
    if (segment == "MSH") {
      // Keep the segment name at index 0, fields are already correctly positioned
      // segmentFields[1] is already MSH-1 (Encoding Characters)
      // segmentFields[2] is already MSH-2 (Sending Application)
    }

    // Create a map of VASpec definitions for quick lookup
    let specMap = new Map();
    if (this.VASpec[segment] != undefined) {
      for (let spec of this.VASpec[segment]) {
        specMap.set(spec.segindex, spec);
      }
    }

    // Iterate through all actual fields in the segment
    for (let fieldIndex = 0; fieldIndex < segmentFields.length; fieldIndex++) {
      let fieldValue = segmentFields[fieldIndex];
      
      // Skip the segment name (index 0) and empty fields
      if (fieldIndex === 0 || fieldValue === '' || fieldValue === undefined) {
        continue;
      }

      let vaspecvalue: any = {
        "segindex": fieldIndex,
        "segfield": "",
        "segtype": "",
        "segvalue": fieldValue,
        "segmentheader": segment,
        "segcomponent": [],
        "isMapped": false, // Default to false
        "mappingInfo": [] // Array of { xmlPath: string, alias: string }
      }

      // Check if this field is defined in VASpec
      if (specMap.has(fieldIndex)) {
        let spec = specMap.get(fieldIndex);
        vaspecvalue.segfield = spec.segfield;
        vaspecvalue.segtype = spec.segtype;
        vaspecvalue.segcomponent = spec.segcomponent;
        
        // Validate the field
        let res = this.myServices.validate(fieldValue, segment, vaspecvalue);
        if (res !== '') {
          vaspecvalue.segtype = '[' + res + ']';
        }
      } else {
        // Field not in spec, show it anyway with generic label
        vaspecvalue.segfield = "Field " + fieldIndex;
      }

      // Check pre-processed mapping status
      if (currectSegment.length > 0) {
        const segmentLine = currectSegment[0];
        const fieldMappingMap = this.segmentMappingStatus.get(segmentLine);
        if (fieldMappingMap) {
          vaspecvalue.isMapped = fieldMappingMap.get(fieldIndex) ?? false;
        }
        // Store mapping info for tooltip
        const fieldMappingInfoMap = this.fieldMappingInfo.get(segmentLine);
        if (fieldMappingInfoMap) {
          vaspecvalue.mappingInfo = fieldMappingInfoMap.get(fieldIndex) || [];
        } else {
          vaspecvalue.mappingInfo = [];
        }
      } else {
        vaspecvalue.mappingInfo = [];
      }

      this.fieldvalues.push(vaspecvalue);
      console.log(this.fieldvalues);
    }
  }

  showdiv: boolean

  getsegmentfieldvaluebyindex(segment: any, dataitem: any) {
    let currectSegment = [];
    let returnvalue = '';
    currectSegment = this.segments.filter((va: string) => va.toUpperCase().includes(segment.toUpperCase()));
    if (currectSegment.length > 0) {
      returnvalue = currectSegment[0].split('|')[dataitem.segindex];
    }
    let res = this.myServices.validate(returnvalue, segment, dataitem);
    if (res !== '') {
      dataitem.segvalue = '[' + res + ']';
      this.showdiv = true
    }
    else {
      this.showdiv = false
    }
    return returnvalue;
  }

  shouldDisplaySegment(header, objsegment): boolean {

    // Call the function to get the return value
    let returnValue = this.getsegmentfieldvaluebyindex(header, objsegment);
    // Return true if the return value is not empty, false otherwise
    return returnValue !== '';

  }
  rowClicked: any;
  arrayindex: any
  segmentcomponentheader: string = 'Name';
  SelectedsegComponentfileds: any = [];
  async selectSegment(segmentname: any, segmentfield: any, HighlightIndex: any, arrayIndex) {

    this.llarrayvalues = []
    this.arrayindex = arrayIndex;
    this.arrayvalues = []
    this.toStoreAccruence = []
    this.rowClickedSub = undefined;
    this.SelectedsegComponentfileds = [];
    this.SelectedSubsegComponentfileds = [];
    this.segmentSubcomponentheader = 'Name';
    this.rowClicked = arrayIndex;
    this.segmentcomponentheader = segmentname + ' ' + segmentfield.segindex;
    
    // Clear filtered mappings cache when switching segments to avoid stale data
    this.filteredMappingsCache.clear();
    this.loadingMappings.clear();

    let currectSegment = [];
    let segmentfieldvalue = '';
    currectSegment = this.segments.filter((va: string) => va.toUpperCase().includes(segmentname.toUpperCase()));

    if (currectSegment.length > 0) {
      // Keep the exact HL7 segment line in sync for context-aware mapping (e.g., OBX.3.1)
      this.currentSegmentLine = currectSegment[0];
      // After fixing MSH parsing, segindex values are already correctly aligned with split array positions
      // No need for special adjustment - use segindex directly for all segments including MSH
      segmentfieldvalue = currectSegment[0].split('|')[segmentfield.segindex];
    }

    // this.highlight(segmentfieldvalue, arrayIndex, this.segments)

    this.highLightFunction(segmentfieldvalue, arrayIndex, HighlightIndex)
    if (segmentname == "MSH") {

      if (segmentfieldvalue.toString().includes("^")) {
        segmentfieldvalue = segmentfieldvalue.replace('^', "star")
      }
    }
    if (segmentfieldvalue == "MSH") {
      segmentfieldvalue = "|"
    }
    segmentfieldvalue = '^' + segmentfieldvalue;


    if (segmentfield.segcomponent.length < segmentfieldvalue.split('^').length) {
      for (let i = segmentfield.segcomponent.length; i < segmentfieldvalue.split('^').length - 1; i++) {
        segmentfield.segcomponent.push({
          segindex: i + 1,
          segfield: '',
          segtype: '',
          segvalue: '',
          segcomponent: [],
        });
      }
    }
    segmentfield.segcomponent.forEach((ele: any) => {

      if (segmentfieldvalue.split('^')[ele.segindex])

        ele.segvalue = segmentfieldvalue.split('^')[ele.segindex];
      if (ele.segvalue.includes("star")) {
        ele.segvalue = ele.segvalue.replaceAll('star', '^')
      }
      if (ele.segvalue != '' && ele.segvalue != undefined) {
        this.SelectedsegComponentfileds.push(ele);
      }

    });
    
    // Proactively load filtered mappings for all components when segment is selected (for interface mode)
    // This ensures the cache is populated when checkmarks are evaluated during template rendering
    if (this.isFromInterface && this.interfaceId && this.processorAgentId && this.SelectedsegComponentfileds.length > 0) {
      // Load mappings for all components in parallel (non-blocking)
      // Build subcomponent paths for each component (e.g., "OBX 3.1.1" for component "OBX 3.1")
      const segHeaderOnly = (this.segmentcomponentheader || '').split(' ')[0];
      Promise.all(
        this.SelectedsegComponentfileds.map((comp: any) => {
          // Build the subcomponent path (component + subcomponent 1) to trigger loading
          const subcomponentPath = this.segmentcomponentheader + '.' + comp.segindex + '.1';
          return this.loadFilteredMappings(subcomponentPath);
        })
      ).then(() => {
        // Trigger change detection after mappings are loaded to update component checkmarks
        this.cdr.markForCheck();
      }).catch(err => console.warn('Error loading component mappings', err));
    }
    
    await this.focus();
    // for double click
    this.matMenuTimer = setTimeout(() => { this.clickedMe(); }, 300);

  }

  segmentSubcomponentheader: string = 'Name';
  SelectedSubsegComponentfileds: any = [];
  rowClickedSub: any;
  async selectSegmentCom(segmentfield: any, index: any) {
    this.SelectedSubsegComponentfileds = [];
    this.rowClickedSub = index;
    this.segmentSubcomponentheader = this.segmentcomponentheader + '.' + segmentfield.segindex;

    // Also ensure current segment line remains aligned with the active component selection
    // so OBX-specific mappings (filtered by OBX.3.1) remain correct when only component
    // rows are clicked without re-clicking the HL7 text area.
    const segHeaderOnly = (this.segmentcomponentheader || '').split(' ')[0];
    // Prefer using the already-set currentSegmentLine if it matches, otherwise find the first matching segment
    const cur = this.segments.find((s: string) => {
      if (!s.startsWith(segHeaderOnly + '|')) return false;
      // If we have a currentSegmentLine and it matches the header, prefer it
      if (this.currentSegmentLine && s === this.currentSegmentLine) return true;
      // Otherwise, return the first match
      return true;
    });
    if (cur) {
      this.currentSegmentLine = cur;
    }

    // Always rebuild subcomponents from the current component value to ensure consistency
    // This ensures component and subcomponent show the same data when appropriate
    let segmentfieldvalue = segmentfield.segvalue || '';
    
    // Remove any '^' prefix that was added during component parsing
    if (segmentfieldvalue.startsWith('^')) {
      segmentfieldvalue = segmentfieldvalue.substring(1);
    }
    
    if (segmentfieldvalue == "^~\\&") {
      this.SelectedSubsegComponentfileds = []
      this.SelectedSubsegComponentfileds.push({
        segindex: this.segmentcomponentheader + '.' + segmentfield.segindex + '.' + 1,
        segfield: '',
        segtype: '',
        segvalue: "^~\\&",
        segcomponent: [],
      });
      return
    }

    // Parse subcomponents by '&' separator (HL7 subcomponent separator)
    // If no '&' exists, the subcomponent value should be the same as component value
    const subcomponentParts = segmentfieldvalue.split('&');
    
    // Always rebuild subcomponents fresh from the component value
    this.SelectedSubsegComponentfileds = [];
    for (let i = 0; i < subcomponentParts.length; i++) {
      const subValue = subcomponentParts[i];
      if (subValue !== '' && subValue !== undefined) {
        this.SelectedSubsegComponentfileds.push({
          segindex: this.segmentcomponentheader + '.' + segmentfield.segindex + '.' + (i + 1),
          segfield: '',
          segtype: '',
          segvalue: subValue,
          segcomponent: [],
        });
      }
    }
    
    // If no subcomponents found (no '&' separator), create one with the same value as component
    if (this.SelectedSubsegComponentfileds.length === 0 && segmentfieldvalue) {
      this.SelectedSubsegComponentfileds.push({
        segindex: this.segmentcomponentheader + '.' + segmentfield.segindex + '.' + 1,
        segfield: '',
        segtype: '',
        segvalue: segmentfieldvalue,
        segcomponent: [],
      });
    }

    // Load filtered mappings from backend for all subcomponents (non-blocking)
    // CRITICAL: Also trigger change detection after loading to update component checkmarks
    if (this.SelectedSubsegComponentfileds.length > 0 && this.isFromInterface && this.interfaceId && this.processorAgentId) {
      // Load mappings for all subcomponents in parallel, but don't await to avoid blocking UI
      Promise.all(
        this.SelectedSubsegComponentfileds.map(sub => 
          this.loadFilteredMappings(sub.segindex)
        )
      ).then(() => {
        // Trigger change detection after mappings are loaded to update component checkmarks
        this.cdr.markForCheck();
      }).catch(err => console.warn('Error loading filtered mappings', err));
    }

    await this.focus();
    // for double click
    this.matMenuTimer = setTimeout(() => { this.clickedMe(); }, 300);
  }

  // --- Mapping integration ---
  private mappingsByPath: Map<string, { xmlPath: string, condition: string } > = new Map();
  private mappingsByPathMulti: Map<string, Array<{ xmlPath: string, condition: string, observationIdentifier?: string }>> = new Map();
  private mappingsRaw: Array<{ HL7Path: string, XMLPath: string, Condition?: string, ObservationIdentifier?: string, CanEdit?: boolean }> = [];

  private async loadMappings(hl7Raw: string, interfaceId: string, processorAgentId: string): Promise<void> {
    return new Promise((resolve) => {
      this.commonService.getHL7Mappings(hl7Raw || '', interfaceId || '', processorAgentId || '').subscribe({
        next: (resp: any) => {
          const list = (resp && resp.mappings) ? resp.mappings : [];
          // Only include mappings that have "Mapped to" (XMLPath) - filter out empty XMLPath
          this.mappingsRaw = list
            .map((m: any) => ({
            HL7Path: (m.HL7Path || m.hL7Path || m.hl7Path || '').toString(),
            XMLPath: (m.XMLPath || m.xMLPath || m.xmlPath || '').toString(),
            Condition: (m.Condition ?? m.condition ?? '').toString(),
            ObservationIdentifier: (m.ObservationIdentifier || '').toString(),
            CanEdit: m.CanEdit !== undefined ? m.CanEdit : true // Default to true if not provided
            }))
            .filter(m => m.XMLPath && m.XMLPath.trim()); // Only keep mappings with "Mapped to" (XMLPath)
          this.mappingsByPath.clear();
          this.mappingsByPathMulti.clear();
          for (const m of list) {
            if (!m) { continue; }
            const key = (m.HL7Path || m.hL7Path || m.hl7Path || '').toString();
            const xmlPath = (m.XMLPath || m.xMLPath || m.xmlPath || '').toString();
            const condition = (m.Condition ?? m.condition ?? '').toString();
            const observationIdentifier = (m.ObservationIdentifier || '').toString();
            if (key && xmlPath) {
              // Store single mapping for backward compatibility
              this.mappingsByPath.set(key, { xmlPath, condition });
              // Store multiple mappings per path
              if (!this.mappingsByPathMulti.has(key)) {
                this.mappingsByPathMulti.set(key, []);
              }
              this.mappingsByPathMulti.get(key)!.push({ xmlPath, condition, observationIdentifier });
            }
          }
          
          // Pre-process mapping status after mappings are loaded
          this.preprocessMappingStatus();
          
          resolve();
        },
        error: () => {
          this.mappingsRaw = [];
          this.preprocessMappingStatus(); // Still process even if no mappings (all fields will be highlighted)
          this.cdr.markForCheck(); // Trigger change detection
          resolve();
        }
      });
    });
  }

  private parseIndices(segIndex: string): { field: number, comp: number, sub: number } {
    // SegIndex is often built like 'PID 5 - Patient Name.5.1.1' or 'PID 5.1.1'
    // Extract the trailing numeric dot pattern (e.g., '5.1.1' or '5.1')
    const m = (segIndex || '').match(/(\d+(?:\.\d+){0,2})$/);
    const idx = m ? m[1] : '';
    const nums = idx.split('.').map(x => parseInt(x, 10)).filter(n => !isNaN(n));
    return { field: nums[0] || 0, comp: nums[1] || 1, sub: nums[2] || 1 };
  }

  private buildHl7Path(segment: string, segIndex: string): string {
    const { field, comp, sub } = this.parseIndices(segIndex);
    const seg = (segment || this.segmentheader || 'PID').trim();
    // Prefer subcomponent path if sub exists
    if (sub && sub !== 1) {
      return `HL7Message/${seg}/${seg}.${field}/${seg}.${field}.${comp}.${sub}`;
    }
    return `HL7Message/${seg}/${seg}.${field}/${seg}.${field}.${comp}`;
  }

  getMappingForSubcomponent(objsub: any): { xmlPath: string, condition: string, canEdit?: boolean } | null {
    const mappings = this.getMappingsForSubcomponent(objsub);
    return mappings && mappings.length > 0 ? mappings[0] : null;
  }

  getMappingsForSubcomponent(objsub: any): Array<{ xmlPath: string, condition: string, canEdit?: boolean, isPending?: boolean, pendingAction?: string }> {
    if (!objsub || !objsub.segindex) return [];
    
    // Get cached mappings for this specific subcomponent
    const cacheKey = objsub.segindex;
    const cached = this.filteredMappingsCache.get(cacheKey);
    
    let baseMappings: Array<{ xmlPath: string, condition: string, canEdit?: boolean }> = [];
    
    // CRITICAL: If cache has entry (even if empty array), use it
    // Empty array means "no mappings" (explicitly checked), undefined means "not loaded yet"
    if (cached !== undefined) {
      if (cached.length === 0) {
        // Explicitly cached as empty - no mappings exist
        baseMappings = [];
      } else {
        // Only return mappings that have XMLPath (Mapped to exists)
        let validMappings = cached.filter(m => m.XMLPath && m.XMLPath.trim());
        
        // SAFEGUARD: For OBX.3.1, filter out any OBX.5.1 mappings that might have been incorrectly cached
        // Parse the segindex to check if this is OBX.3.1
        const indices = this.parseIndices(cacheKey);
        const segHeader = (this.segmentcomponentheader || '').split(' ')[0];
        if (segHeader.toUpperCase() === 'OBX' && indices.field === 3 && indices.comp === 1) {
          validMappings = validMappings.filter(m => {
            const hl7Path = (m.HL7Path || '').toUpperCase();
            // Exclude OBX.5.1 mappings
            const isObx51 = hl7Path.includes('OBX.5/OBX.5.1') || 
                           hl7Path.includes('OBX.5/OBX.5/OBX.5.1');
            if (isObx51) return false;
            
            // Only include if it's actually an OBX.3.1 mapping (target, not in predicate)
            const predicateEndIndex = hl7Path.lastIndexOf(']');
            const pathAfterPredicate = predicateEndIndex >= 0 
              ? hl7Path.substring(predicateEndIndex + 1)
              : hl7Path;
            
            return pathAfterPredicate.includes('OBX.3/OBX.3.1') || 
                   pathAfterPredicate.includes('OBX.3/OBX.3/OBX.3.1') ||
                   (hl7Path.includes('COUNT(') && hl7Path.includes('OBX.3/OBX.3.1') && !hl7Path.includes('OBX.5'));
          });
        }
        
        if (validMappings.length > 0) {
          baseMappings = validMappings.map(m => ({
            xmlPath: m.XMLPath || '',
            condition: m.Condition || '',
            canEdit: m.CanEdit !== undefined ? m.CanEdit : true
          }));
        }
      }
    }
    
    // CRITICAL: In interface mode, if cache is undefined, don't use fallback - trigger load instead
    // This ensures backend is always the source of truth in interface mode
    if (this.isFromInterface && cached === undefined) {
      // Cache is undefined - trigger async load (but don't wait for it in this sync method)
      // The loadFilteredMappings will populate the cache, and UI will update via change detection
      this.loadFilteredMappings(cacheKey);
      // Continue to merge pending changes even if cache is not ready
    }
    
    // If not cached and we have all mappings loaded, try to find matches from allMappings
    // This is the fallback for non-interface mode only
    if (baseMappings.length === 0 && this.mappingsRaw && this.mappingsRaw.length > 0 && !this.isFromInterface) {
      const segHeader = (this.segmentcomponentheader || '').split(' ')[0];
      const indices = this.parseIndices(objsub.segindex);
      
      // Build target path fragment (e.g., "OBX.5/OBX.5.1" or "PID.5/PID.5.1")
      const targetPathFragment = segHeader + '.' + indices.field + '/' + segHeader + '.' + indices.field + '.' + indices.comp;
      
      // For OBX segments, handle conditional matching
      if (segHeader === 'OBX') {
        // Extract OBX.3.1 identifier from current segment line
        let obxIdentifier = '';
        if (this.currentSegmentLine) {
          try {
            const fields = (this.currentSegmentLine || '').split('|');
            if (fields.length > 3) {
              const obx3 = fields[3];
              obxIdentifier = obx3.split('^')[0] || '';
            }
          } catch { /* ignore */ }
        }

        // Special handling for OBX.3.1 - exclude OBX.5.1 mappings AND match by identifier
        if (indices.field === 3 && indices.comp === 1) {
          const matches = this.mappingsRaw.filter(m => {
            // PRIMARY CHECK: "Mapped to" (XMLPath) must exist and not be empty
            if (!m.XMLPath || !m.XMLPath.trim()) return false;
            
            const storedPath = (m.HL7Path || '').toUpperCase();
            
            // CRITICAL FIX: First check if this is an OBX.5.1 mapping (which should NEVER be shown for OBX.3.1)
            // Check path content to be absolutely sure - OBX.5.1 mappings have "OBX.5/OBX.5.1" in the path
            const isObx51 = storedPath.includes('OBX.5/OBX.5.1') || 
                           storedPath.includes('OBX.5/OBX.5/OBX.5.1');
            
            // If it's an OBX.5.1 mapping, exclude it immediately (even if path contains OBX.3.1 in predicate)
            if (isObx51) return false;
            
            // Now check if mapping is actually for OBX.3.1 (the target, not in predicate)
            // Check if OBX.3.1 appears as the target (after closing bracket of predicate, if any)
            const predicateEndIndex = storedPath.lastIndexOf(']');
            const pathAfterPredicate = predicateEndIndex >= 0 
              ? storedPath.substring(predicateEndIndex + 1)
              : storedPath;
            
            // OBX.3.1 should be the target (after predicate), not just referenced in predicate
            const isObx31 = pathAfterPredicate.includes('OBX.3/OBX.3.1') || 
                           pathAfterPredicate.includes('OBX.3/OBX.3/OBX.3.1') ||
                           // For count functions: count(HL7Message/OBX[OBX.3/OBX.3.1='...'])
                           (storedPath.includes('COUNT(') &&
                            storedPath.includes('OBX.3/OBX.3.1') &&
                            !storedPath.includes('OBX.5'));
            
            // If it's not an OBX.3.1 mapping, exclude it
            if (!isObx31) return false;
            
            // CRITICAL: If we have an identifier and the mapping has one, they must match
            if (obxIdentifier && m.ObservationIdentifier) {
              return m.ObservationIdentifier === obxIdentifier;
            }
            
            // If mapping has no ObservationIdentifier, include it (direct mapping)
            // If we have no identifier, include all OBX.3.1 mappings with XMLPath
            return true;
          });
          
          if (matches.length > 0) {
            baseMappings = matches.map(m => ({
              xmlPath: m.XMLPath || '',
              condition: m.Condition || '',
              canEdit: m.CanEdit !== undefined ? m.CanEdit : true
            }));
          }
        } else {
          // For other OBX fields, match by path and identifier
          const matches = this.mappingsRaw.filter(m => {
            // PRIMARY CHECK: "Mapped to" (XMLPath) must exist and not be empty
            if (!m.XMLPath || !m.XMLPath.trim()) return false;
            
            const storedPath = (m.HL7Path || '').toUpperCase();
            const pathMatch = storedPath.includes(targetPathFragment.toUpperCase());
            
            if (!pathMatch) return false;
            
            // If we have an identifier, check if it matches
            if (obxIdentifier && m.ObservationIdentifier) {
              return m.ObservationIdentifier === obxIdentifier;
            }
            
            // If no identifier in mapping, include it (has XMLPath)
            return true;
          });
          
          if (matches.length > 0) {
            baseMappings = matches.map(m => ({
              xmlPath: m.XMLPath || '', 
              condition: m.Condition || '',
              canEdit: m.CanEdit !== undefined ? m.CanEdit : true
            }));
          }
        }
      } else {
        // For non-OBX segments, simple path matching
        const matches = this.mappingsRaw.filter(m => {
          // PRIMARY CHECK: "Mapped to" (XMLPath) must exist and not be empty
          if (!m.XMLPath || !m.XMLPath.trim()) return false;

          const storedPath = (m.HL7Path || '').toUpperCase();
          return storedPath.includes(targetPathFragment.toUpperCase());
        });
        
        if (matches.length > 0) {
          baseMappings = matches.map(m => ({
            xmlPath: m.XMLPath || '', 
            condition: m.Condition || '',
            canEdit: m.CanEdit !== undefined ? m.CanEdit : true
          }));
        }
      }
    }

    // CHANGED: Merge pending changes with base mappings for batch editing
    // REVERT: Remove this section to revert to showing only base mappings
    if (this.isFromInterface) {
      const pendingChanges = this.pendingChanges.get(cacheKey) || [];
      const resultMappings: Array<{ xmlPath: string, condition: string, canEdit?: boolean, isPending?: boolean, pendingAction?: string }> = [];
      const segHeader = (this.segmentcomponentheader || '').split(' ')[0];
      const currentHl7PathForSeg = this.buildHl7Path(segHeader, cacheKey);
      
      // Start with base mappings, mark which ones have pending changes
      baseMappings.forEach(baseMapping => {
        // Find pending change that matches this mapping (by xmlPath and hl7Path)
        const pendingChange = pendingChanges.find(pc => 
          pc.mapping.xmlPath === baseMapping.xmlPath && 
          pc.mapping.hl7Path === currentHl7PathForSeg
        );
        
        if (pendingChange) {
          if (pendingChange.action === 'delete') {
            // Don't include deleted mappings
            return;
          } else if (pendingChange.action === 'update') {
            // Include updated version
            resultMappings.push({
              xmlPath: pendingChange.mapping.xmlPath,
              condition: pendingChange.mapping.condition,
              canEdit: baseMapping.canEdit,
              isPending: true,
              pendingAction: 'update'
            });
          } else {
            // Include as-is with pending flag
            resultMappings.push({
              ...baseMapping,
              isPending: true,
              pendingAction: pendingChange.action
            });
          }
        } else {
          // No pending change, include as-is
          resultMappings.push(baseMapping);
        }
      });
      
      // Add pending additions that aren't in base mappings
      pendingChanges.forEach(pendingChange => {
        if (pendingChange.action === 'add') {
          const exists = baseMappings.some(bm => 
            bm.xmlPath === pendingChange.mapping.xmlPath &&
            bm.condition === pendingChange.mapping.condition
          );
          if (!exists) {
            resultMappings.push({
              xmlPath: pendingChange.mapping.xmlPath,
              condition: pendingChange.mapping.condition,
              canEdit: true,
              isPending: true,
              pendingAction: 'add'
            });
          }
        }
      });
      
      return resultMappings;
    }

    // Don't trigger async loads from within template rendering - this causes infinite loops
    // Mappings should be loaded proactively in selectSegmentCom or openMappingModal
    return baseMappings;
  }

  // Cache for filtered mappings from backend - keyed by segIndex
  private filteredMappingsCache: Map<string, Array<{ HL7Path: string, XMLPath: string, Condition?: string, ObservationIdentifier?: string, CanEdit?: boolean }>> = new Map();
  
  // Track loading states to prevent duplicate requests
  private loadingMappings: Set<string> = new Set();
  
  // Load filtered mappings from backend
  private async loadFilteredMappings(segIndex: string): Promise<void> {
    if (!this.isFromInterface || !this.interfaceId || !this.processorAgentId) {
      return;
    }
    
    // Skip if already cached or currently loading
    if (this.filteredMappingsCache.has(segIndex) || this.loadingMappings.has(segIndex)) {
      return;
    }
    
    // Mark as loading
    this.loadingMappings.add(segIndex);
    
    const segHeader = (this.segmentcomponentheader || '').split(' ')[0];
    
    try {
      const resp = await this.commonService.getFilteredHL7Mappings(
        this.inputdata || '',
        this.interfaceId,
        this.processorAgentId,
        this.currentSegmentLine,
        segHeader,
        segIndex
      ).toPromise();
      
      const list = (resp && resp.mappings) ? resp.mappings : [];
      let mapped = list
        .map((m: any) => ({
          HL7Path: (m.HL7Path || m.hL7Path || m.hl7Path || '').toString(),
          XMLPath: (m.XMLPath || m.xMLPath || m.xmlPath || '').toString(),
          Condition: (m.Condition ?? m.condition ?? '').toString(),
          ObservationIdentifier: (m.ObservationIdentifier || '').toString(),
          CanEdit: m.CanEdit !== undefined ? m.CanEdit : true // Default to true if not provided
        }))
        .filter(m => m.XMLPath && m.XMLPath.trim()); // Only cache mappings that have "Mapped to" (XMLPath)
      
      // CRITICAL SAFEGUARD: For OBX.3.1 queries, filter out any OBX.5.1 mappings that backend might have incorrectly returned
      // Parse segIndex to check if this is OBX.3.1
      const indices = this.parseIndices(segIndex);
      if (segHeader.toUpperCase() === 'OBX' && indices.field === 3 && indices.comp === 1) {
        mapped = mapped.filter(m => {
          const hl7Path = (m.HL7Path || '').toUpperCase();
          // Exclude OBX.5.1 mappings
          const isObx51 = hl7Path.includes('OBX.5/OBX.5.1') || 
                         hl7Path.includes('OBX.5/OBX.5/OBX.5.1');
          if (isObx51) return false;
          
          // Only include if it's actually an OBX.3.1 mapping (target, not in predicate)
          const predicateEndIndex = hl7Path.lastIndexOf(']');
          const pathAfterPredicate = predicateEndIndex >= 0 
            ? hl7Path.substring(predicateEndIndex + 1)
            : hl7Path;
          
          return pathAfterPredicate.includes('OBX.3/OBX.3.1') || 
                 pathAfterPredicate.includes('OBX.3/OBX.3/OBX.3.1') ||
                 (hl7Path.includes('COUNT(') && hl7Path.includes('OBX.3/OBX.3.1') && !hl7Path.includes('OBX.5'));
        });
      }
      
      // Cache the results (only mappings with XMLPath, and filtered for OBX.3.1)
      // IMPORTANT: Cache empty array if no valid mappings, so we know there are none (not just "not loaded yet")
      this.filteredMappingsCache.set(segIndex, mapped);
      
      // Trigger change detection to update checkmarks after cache is populated
      // Use requestAnimationFrame to trigger change detection asynchronously, avoiding infinite loops
      // This is safer than setTimeout as it runs before the next repaint
      requestAnimationFrame(() => {
        this.cdr.markForCheck(); // Use markForCheck instead of detectChanges to avoid immediate execution
      });
    } catch (error) {
      console.warn('Failed to load filtered mappings', error);
      // Cache empty array to prevent repeated failed calls
      this.filteredMappingsCache.set(segIndex, []);
    } finally {
      // Remove from loading set
      this.loadingMappings.delete(segIndex);
    }
  }

  // Parse HL7 path to extract the actual target segment, field, component, and subcomponent
  // Matches backend ParseHl7Indices logic exactly
  private parseHl7Indices(hl7Path: string): { segment: string | null, field: number, comp: number, sub: number } {
    if (!hl7Path || !hl7Path.trim()) return { segment: null, field: 0, comp: 0, sub: 0 };
    
    const pathUpper = hl7Path.toUpperCase();
    
    // Extract segment name - look for pattern like HL7Message/SEGMENT or /SEGMENT (may be followed by [])
    // Backend uses: SegmentExtractRegex which matches segment name before [ or /
    const segMatch = pathUpper.match(/HL7MESSAGE\/([A-Z0-9]+)(?:\[|\/|$)/i) || 
                     pathUpper.match(/\/([A-Z0-9]+)(?:\[|\/|$)/);
    if (!segMatch) return { segment: null, field: 0, comp: 0, sub: 0 };
    
    const segment = segMatch[1];
    const escapedSegment = segment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    
    // CRITICAL: Find the target AFTER any predicate brackets
    // Example: "HL7Message/OBX[OBX.3/OBX.3.1='Specimen Test Requested']/OBX.5/OBX.5.1"
    // We need to find OBX.5/OBX.5.1 (after the ]), NOT OBX.3/OBX.3.1 (inside the predicate)
    const predicateEndIndex = pathUpper.lastIndexOf(']');
    const pathToSearch = predicateEndIndex >= 0 
      ? pathUpper.substring(predicateEndIndex + 1) 
      : pathUpper;
    
    // Match full pattern: <SEG>.<field>/<SEG>.<field>.<comp>[.<sub>]
    // Backend pattern: {segment}\.(\d+)/(?:{segment}\.\d+/)?{segment}\.\d+\.(\d+)(?:\.(\d+))?
    // Examples: PID.5/PID.5.1 or OBX.5/OBX.5.1 or /OBX.5/OBX.5.1 (after predicate)
    const fullPattern = new RegExp(
      `${escapedSegment}\\.(\\d+)\\/(?:${escapedSegment}\\.\\d+\\/)?${escapedSegment}\\.\\d+\\.(\\d+)(?:\\.(\\d+))?`,
      'gi'
    );
    
    // Find the LAST match (in case there are multiple matches, we want the actual target)
    // Use matchAll to safely get all matches without infinite loop
    const fullMatches = Array.from(pathToSearch.matchAll(fullPattern));
    if (fullMatches.length > 0) {
      const lastFullMatch = fullMatches[fullMatches.length - 1];
      const field = parseInt(lastFullMatch[1]) || 0;
      const comp = parseInt(lastFullMatch[2]) || 0;
      const sub = lastFullMatch[3] ? (parseInt(lastFullMatch[3]) || 0) : 0;
      // Only return if we got valid component (comp > 0), otherwise try alternative pattern
      if (comp > 0) {
        return { segment, field, comp, sub };
      }
    }
    
    // Try alternative pattern for paths like HL7Message/DG1/DG1.4/DG1.4.1 where segment appears in path
    // Pattern: HL7MESSAGE/SEGMENT/SEGMENT.field/SEGMENT.field.comp[.sub] or /SEGMENT/SEGMENT.field/SEGMENT.field.comp[.sub]
    const altPattern1 = new RegExp(
      `HL7MESSAGE\\/${escapedSegment}\\/${escapedSegment}\\.(\\d+)\\/${escapedSegment}\\.\\d+\\.(\\d+)(?:\\.(\\d+))?`,
      'gi'
    );
    const altMatches1 = Array.from(pathToSearch.matchAll(altPattern1));
    if (altMatches1.length > 0) {
      const lastAltMatch = altMatches1[altMatches1.length - 1];
      const field = parseInt(lastAltMatch[1]) || 0;
      const comp = parseInt(lastAltMatch[2]) || 0;
      const sub = lastAltMatch[3] ? (parseInt(lastAltMatch[3]) || 0) : 0;
      if (comp > 0) {
        return { segment, field, comp, sub };
      }
    }
    
    // Try pattern: /SEGMENT/SEGMENT.field/SEGMENT.field.comp[.sub] (without HL7Message prefix)
    const altPattern2 = new RegExp(
      `\\/${escapedSegment}\\/${escapedSegment}\\.(\\d+)\\/${escapedSegment}\\.\\d+\\.(\\d+)(?:\\.(\\d+))?`,
      'gi'
    );
    const altMatches2 = Array.from(pathToSearch.matchAll(altPattern2));
    if (altMatches2.length > 0) {
      const lastAltMatch = altMatches2[altMatches2.length - 1];
      const field = parseInt(lastAltMatch[1]) || 0;
      const comp = parseInt(lastAltMatch[2]) || 0;
      const sub = lastAltMatch[3] ? (parseInt(lastAltMatch[3]) || 0) : 0;
      if (comp > 0) {
        return { segment, field, comp, sub };
      }
    }
    
    // Try direct pattern: SEGMENT.field/SEGMENT.field.comp (matches anywhere in path)
    // This is a fallback for paths that don't match the above patterns
    const directPattern = new RegExp(
      `(?:^|\\/|\\\\)${escapedSegment}\\.(\\d+)\\/${escapedSegment}\\.\\d+\\.(\\d+)(?:\\.(\\d+))?`,
      'gi'
    );
    const directMatches = Array.from(pathToSearch.matchAll(directPattern));
    if (directMatches.length > 0) {
      const lastDirectMatch = directMatches[directMatches.length - 1];
      const field = parseInt(lastDirectMatch[1]) || 0;
      const comp = parseInt(lastDirectMatch[2]) || 0;
      const sub = lastDirectMatch[3] ? (parseInt(lastDirectMatch[3]) || 0) : 0;
      if (comp > 0) {
        return { segment, field, comp, sub };
      }
    }
    
    // Try simpler pattern: HL7Message/<SEG>/<SEG>.<field> (field only, no component)
    // Backend pattern: HL7Message/{segment}(?:\[[^\]]*\])?/{segment}\.(\d+)
    const simplePattern = new RegExp(
      `${escapedSegment}\\.(\\d+)`,
      'gi'
    );
    
    // Find the LAST match after the predicate
    const simpleMatches = Array.from(pathToSearch.matchAll(simplePattern));
    if (simpleMatches.length > 0) {
      const lastSimpleMatch = simpleMatches[simpleMatches.length - 1];
      const field = parseInt(lastSimpleMatch[1]) || 0;
      return { segment, field, comp: 0, sub: 0 };
    }
    
    return { segment: null, field: 0, comp: 0, sub: 0 };
  }

  /**
   * Pre-processes all segments to determine which fields are mapped/unmapped
   * This is called once after mappings are loaded
   */
  private preprocessMappingStatus(): void {
    this.segmentMappingStatus.clear();
    this.fieldMappingInfo.clear();
    this.splittedContentWithHighlights = [];
    
    if (!this.splittedContent || this.splittedContent.length === 0) {
      return;
    }

    if (!this.isFromInterface) {
      return;
    }
    
    // Process each segment line
    for (let lineIndex = 0; lineIndex < this.splittedContent.length; lineIndex++) {
      const segmentLine = this.splittedContent[lineIndex];
      if (!segmentLine || !segmentLine.trim() || !segmentLine.includes('|')) {
        // Non-segment line - sanitize and add as-is
        this.splittedContentWithHighlights.push(this.sanitizer.bypassSecurityTrustHtml(segmentLine));
        continue;
      }
      
      const fields = segmentLine.split('|');
      const segmentName = fields[0]?.toUpperCase() || '';
      
      if (!segmentName) {
        // Invalid segment - sanitize and add as-is
        this.splittedContentWithHighlights.push(this.sanitizer.bypassSecurityTrustHtml(segmentLine));
        continue;
      }
      
      // Create map for this segment line
      const fieldMappingMap = new Map<number, boolean>();
      const fieldMappingInfoMap = new Map<number, Array<{ xmlPath: string, alias: string }>>();
      
      // Extract OBX.3.1 (ObservationIdentifier) if this is an OBX segment
      let obxIdentifier = '';
      if (segmentName === 'OBX' && fields.length > 3) {
        try {
          const obx3 = fields[3];
          obxIdentifier = obx3.split('^')[0] || '';
        } catch { /* ignore */ }
      }
      
      // Check each field for mappings
      // Skip field 0 (segment name) and empty fields
      for (let fieldIndex = 1; fieldIndex < fields.length; fieldIndex++) {
        const fieldValue = fields[fieldIndex];
        
        if (!fieldValue || fieldValue.trim() === '') {
          fieldMappingMap.set(fieldIndex, false);
          fieldMappingInfoMap.set(fieldIndex, []);
          continue;
        }
        
        // Get mappings for this field (returns array of mappings with XMLPath and alias)
        const mappings = this.getFieldMappings(segmentName, fieldIndex, segmentLine, obxIdentifier);
        const hasMapping = mappings.length > 0;
        fieldMappingMap.set(fieldIndex, hasMapping);
        fieldMappingInfoMap.set(fieldIndex, mappings);
      }
      
      // Store mapping status and info for this segment line
      this.segmentMappingStatus.set(segmentLine, fieldMappingMap);
      this.fieldMappingInfo.set(segmentLine, fieldMappingInfoMap);
      
      // Create highlighted version of the segment line
      const highlightedLine = this.createHighlightedSegmentLine(segmentLine, fieldMappingMap, fieldMappingInfoMap);
      // Sanitize the HTML before storing
      this.splittedContentWithHighlights.push(this.sanitizer.bypassSecurityTrustHtml(highlightedLine));
    }
    
    // Trigger change detection to update the UI
    this.cdr.markForCheck();
    
    // Debug: Log to verify tooltips are being generated
    if (this.splittedContentWithHighlights.length > 0) {
      console.log('Preprocessing complete. Total lines:', this.splittedContentWithHighlights.length);
      // Check for mapped fields with tooltips
      const sampleHtml = this.splittedContentWithHighlights.find(line => 
        line?.toString().includes('mapped-field')
      );
      if (sampleHtml) {
        console.log('Sample mapped field HTML:', sampleHtml.toString().substring(0, 400));
      }
    }
  }

  /**
   * Gets all mappings for a specific field with XMLPath and alias
   * Optionally filters by component index if provided
   */
  private getFieldMappings(segmentName: string, fieldIndex: number, segmentLine: string, obxIdentifier: string, componentIndex?: number): Array<{ xmlPath: string, alias: string }> {
    if (!this.mappingsRaw || this.mappingsRaw.length === 0) {
      return [];
    }
    
    const segmentUpper = segmentName.toUpperCase();
    const mappings: Array<{ xmlPath: string, alias: string }> = [];
    
    for (const m of this.mappingsRaw) {
      // PRIMARY CHECK: "Mapped to" (XMLPath) must exist and not be empty
      const xmlPath = (m.XMLPath || '').trim();
      if (!xmlPath) continue;
      
      const hl7Path = (m.HL7Path || '').trim();
      if (!hl7Path) continue;
      
      // Parse the actual target from the HL7Path (includes component and subcomponent)
      const { segment: mappingSegment, field: mappingField, comp: mappingComp } = this.parseHl7Indices(hl7Path);
      
      // Must match the segment and field exactly
      if (!mappingSegment || mappingSegment.toUpperCase() !== segmentUpper) continue;
      if (mappingField !== fieldIndex) continue;
      
      // If componentIndex is provided, filter by component level
      // This ensures we only get mappings for the specific component (e.g., PID.5.1 vs PID.5.2)
      if (componentIndex !== undefined && componentIndex > 0) {
        // Only include mappings that match this specific component
        // If mapping has no component (comp=0), it's a field-level mapping - exclude it when filtering by component
        if (mappingComp === 0 || mappingComp !== componentIndex) continue;
      }
      
      // CRITICAL: For OBX segments, check ObservationIdentifier match
      if (segmentUpper === 'OBX' && obxIdentifier) {
        // If mapping has ObservationIdentifier, it must match current segment's OBX.3.1
        if (m.ObservationIdentifier) {
          if (m.ObservationIdentifier !== obxIdentifier) continue;
        }
        // If mapping has no ObservationIdentifier, it's unconditional - include it
      }
      
      // Get alias for this XMLPath
      const alias = this.getAliasForMapping(xmlPath);
      mappings.push({ xmlPath, alias });
    }
    
    return mappings;
  }

  /**
   * Checks if a specific field has a mapping (for backward compatibility)
   */
  private checkFieldMapping(segmentName: string, fieldIndex: number, segmentLine: string, obxIdentifier: string): boolean {
    const mappings = this.getFieldMappings(segmentName, fieldIndex, segmentLine, obxIdentifier);
    return mappings.length > 0;
  }

  /**
   * Creates a highlighted version of the segment line with unmapped fields wrapped in spans
   * and mapped fields with tooltips showing mapping information
   * For fields with components (separated by "^"), each component is wrapped separately
   */
  private createHighlightedSegmentLine(segmentLine: string, fieldMappingMap: Map<number, boolean>, fieldMappingInfoMap: Map<number, Array<{ xmlPath: string, alias: string }>>): string {
    const fields = segmentLine.split('|');
    const highlightedFields: string[] = [];
    
    // Always include segment name (field 0)
    highlightedFields.push(fields[0] || '');
    
    const segmentName = (fields[0] || '').toUpperCase();
    let obxIdentifier = '';
    if (segmentName === 'OBX' && fields.length > 3) {
      try {
        const obx3 = fields[3];
        obxIdentifier = obx3.split('^')[0] || '';
      } catch { /* ignore */ }
    }
    
    // Process each field
    for (let i = 1; i < fields.length; i++) {
      const fieldValue = fields[i] || '';
      const isMapped = fieldMappingMap.get(i) ?? false;
      const fieldMappings = fieldMappingInfoMap.get(i) || [];
      
      if (!isMapped && fieldValue.trim() !== '') {
        // Unmapped field - wrap with red highlight span
        highlightedFields.push(`<span class="unmapped-field">${this.escapeHtml(fieldValue)}</span>`);
      } else if (isMapped && fieldValue.trim() !== '') {
        // Mapped field - check if it has components (separated by "^")
        const components = fieldValue.split('^');
        
        if (components.length > 1) {
          // Field has multiple components - wrap each component separately
          const highlightedComponents: string[] = [];
          
          for (let compIndex = 0; compIndex < components.length; compIndex++) {
            const componentValue = components[compIndex] || '';
            const componentNumber = compIndex + 1; // Component numbers are 1-based (PID.5.1, PID.5.2, etc.)
            
            // Get mappings specifically for this component
            const componentMappings = this.getFieldMappings(segmentName, i, segmentLine, obxIdentifier, componentNumber);
            const hasComponentMapping = componentMappings.length > 0;
            
            if (!hasComponentMapping && componentValue.trim() !== '') {
              // Unmapped component - wrap with red highlight
              highlightedComponents.push(`<span class="unmapped-field">${this.escapeHtml(componentValue)}</span>`);
            } else if (hasComponentMapping && componentValue.trim() !== '') {
              // Mapped component - wrap with tooltip
              const tooltipText = this.getMappingTooltipText(componentMappings);
              if (tooltipText) {
                const escapedTooltip = this.escapeHtmlAttribute(tooltipText);
                highlightedComponents.push(`<span class="mapped-field" data-tooltip="${escapedTooltip}" title="${escapedTooltip}">${this.escapeHtml(componentValue)}</span>`);
              } else {
                highlightedComponents.push(`<span class="mapped-field">${this.escapeHtml(componentValue)}</span>`);
              }
            } else {
              // Empty component or no mapping - keep as is
              highlightedComponents.push(this.escapeHtml(componentValue));
            }
          }
          
          // Rejoin components with "^" separator
          highlightedFields.push(highlightedComponents.join('^'));
        } else {
          // Field has no components (or single value) - use field-level mappings
          if (fieldMappings.length > 0) {
            const tooltipText = this.getMappingTooltipText(fieldMappings);
            if (tooltipText) {
              const escapedTooltip = this.escapeHtmlAttribute(tooltipText);
              highlightedFields.push(`<span class="mapped-field" data-tooltip="${escapedTooltip}" title="${escapedTooltip}">${this.escapeHtml(fieldValue)}</span>`);
            } else {
              highlightedFields.push(`<span class="mapped-field">${this.escapeHtml(fieldValue)}</span>`);
            }
          } else {
            // Mapped field but no mapping info - keep as is
            highlightedFields.push(this.escapeHtml(fieldValue));
          }
        }
      } else {
        // Empty field or unmapped - keep as is
        highlightedFields.push(this.escapeHtml(fieldValue));
      }
    }
    
    return highlightedFields.join('|');
  }

  /**
   * Gets tooltip text for mapping info (used in raw text highlighting)
   * Shows alias if available, otherwise shows XMLPath
   * CHANGED: Now shows ALL mappings (not just first one) when isFromInterface is true
   */
  private getMappingTooltipText(mappings: Array<{ xmlPath: string, alias: string }>): string {
    if (!mappings || mappings.length === 0) {
      return '';
    }
    
    // REVERT: To show only first mapping, uncomment below and remove the "Show all mappings" section
    // const firstMapping = mappings[0];
    // if (firstMapping.alias && firstMapping.alias !== firstMapping.xmlPath) {
    //   return firstMapping.alias;
    // } else {
    //   return firstMapping.xmlPath;
    // }
    
    // CHANGED: Show all mappings when isFromInterface is true
    if (this.isFromInterface && mappings.length > 1) {
      const tooltips: string[] = [];
      for (const mapping of mappings) {
        if (mapping.alias && mapping.alias !== mapping.xmlPath) {
          // Show only alias (not XPath) when available
          tooltips.push(mapping.alias);
        } else {
          // Show XMLPath if no alias (fallback)
          tooltips.push(mapping.xmlPath);
        }
      }
      return tooltips.join('\n\n');
    }
    
    // For single mapping or non-interface mode, show first mapping
    const firstMapping = mappings[0];
    if (firstMapping.alias && firstMapping.alias !== firstMapping.xmlPath) {
      // Show only alias (not XPath) when available
      return firstMapping.alias;
    } else {
      return firstMapping.xmlPath;
    }
  }

  /**
   * Escapes HTML attribute values to prevent XSS
   */
  private escapeHtmlAttribute(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /**
   * Escapes HTML to prevent XSS
   */
  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Check if a field has any mappings - show checkmark ONLY if "Mapped to" (XMLPath) exists
  // For OBX segments, also checks ObservationIdentifier to match current segment
  hasMappingForField(segment: string, fieldIndex: number): boolean {
    if (!segment || !fieldIndex || !this.mappingsRaw || this.mappingsRaw.length === 0) return false;
    const segmentUpper = segment.toUpperCase();
    
    // For OBX segments, extract the ObservationIdentifier (OBX.3.1) from current segment line
    let obxIdentifier = '';
    if (segmentUpper === 'OBX' && this.currentSegmentLine) {
      try {
        const fields = (this.currentSegmentLine || '').split('|');
        if (fields.length > 3) {
          const obx3 = fields[3];
          obxIdentifier = obx3.split('^')[0] || '';
        }
      } catch { /* ignore */ }
    }
    
    return this.mappingsRaw.some(m => {
      // PRIMARY CHECK: "Mapped to" (XMLPath) must exist and not be empty
      const xmlPath = (m.XMLPath || '').trim();
      if (!xmlPath) return false; // No mapping if XMLPath is empty
      
      const hl7Path = (m.HL7Path || '').trim();
      if (!hl7Path) return false;
      
      // Parse the actual target from the HL7Path
      const { segment: mappingSegment, field: mappingField } = this.parseHl7Indices(hl7Path);
      
      // Must match the segment and field exactly
      if (!mappingSegment || mappingSegment.toUpperCase() !== segmentUpper) return false;
      if (mappingField !== fieldIndex) return false;
      
      // CRITICAL: For OBX segments, check ObservationIdentifier match
      if (segmentUpper === 'OBX' && obxIdentifier) {
        // If mapping has ObservationIdentifier, it must match current segment's OBX.3.1
        if (m.ObservationIdentifier) {
          if (m.ObservationIdentifier !== obxIdentifier) return false;
        }
        // If mapping has no ObservationIdentifier, it's unconditional - include it
      }
      
      // XMLPath exists for this field - show checkmark
      return true;
    });
  }

  // Check if a component has any mappings - show checkmark ONLY if "Mapped to" (XMLPath) exists
  // CRITICAL: Uses the EXACT same cache lookup as getMappingsForSubcomponent to ensure 100% consistency
  // For a component (e.g., "OBX 3.1"), check if its first subcomponent (e.g., "OBX 3.1.1") has mappings
  hasMappingForComponent(segment: string, fieldIndex: number, componentIndex: number): boolean {
    if (!segment || !fieldIndex || !componentIndex) return false;
    
    // Build the subcomponent path for the first subcomponent (e.g., "OBX 3.1.1")
    // This matches exactly how getMappingsForSubcomponent uses objsub.segindex
    const subcomponentPath = this.segmentcomponentheader + '.' + componentIndex + '.1';
    
    // CRITICAL: In interface mode, ONLY use cached filtered mappings (backend is source of truth)
    // Do NOT use mappingsRaw fallback - this ensures consistency and prevents incorrect checkmarks
    if (this.isFromInterface) {
      // Check cached mappings directly (same as getMappingsForSubcomponent does first)
      const cached = this.filteredMappingsCache.get(subcomponentPath);
      
      // If cache has entry (even if empty array), use it
      // Empty array means "no mappings" (explicitly checked), undefined means "not loaded yet"
      if (cached !== undefined) {
        if (cached.length === 0) {
          // Explicitly cached as empty - no mappings exist
          return false;
        }
        
        // SAFEGUARD: For OBX.3.1, filter out any OBX.5.1 mappings that might have been incorrectly cached
        // This ensures that even if backend returned wrong data, we don't show checkmark for OBX.3.1
        let validMappings = cached.filter(m => m.XMLPath && m.XMLPath.trim());
        
        // Additional safeguard for OBX.3.1: exclude OBX.5.1 mappings
        if (segment.toUpperCase() === 'OBX' && fieldIndex === 3 && componentIndex === 1) {
          validMappings = validMappings.filter(m => {
      const hl7Path = (m.HL7Path || '').toUpperCase();
            // Exclude OBX.5.1 mappings
            const isObx51 = hl7Path.includes('OBX.5/OBX.5.1') || 
                           hl7Path.includes('OBX.5/OBX.5/OBX.5.1');
            if (isObx51) return false;
            
            // Only include if it's actually an OBX.3.1 mapping (target, not in predicate)
            const predicateEndIndex = hl7Path.lastIndexOf(']');
            const pathAfterPredicate = predicateEndIndex >= 0 
              ? hl7Path.substring(predicateEndIndex + 1)
              : hl7Path;
            
            return pathAfterPredicate.includes('OBX.3/OBX.3.1') || 
                   pathAfterPredicate.includes('OBX.3/OBX.3/OBX.3.1') ||
                   (hl7Path.includes('COUNT(') && hl7Path.includes('OBX.3/OBX.3.1') && !hl7Path.includes('OBX.5'));
          });
        }
        
        return validMappings.length > 0;
      }
      // In interface mode, if cache doesn't have it yet (undefined), return false (no checkmark until cache is populated)
      // This prevents showing incorrect checkmarks based on incomplete or incorrect mappingsRaw data
      return false;
    }
    
    // FALLBACK: Only for non-interface mode - use getMappingsForSubcomponent which has mappingsRaw fallback
    const mockSubcomponent = { segindex: subcomponentPath };
    const mappings = this.getMappingsForSubcomponent(mockSubcomponent);
    
    // Return true only if there are mappings with XMLPath (same as what's shown in UI)
    return mappings && mappings.length > 0 && mappings.some(m => m.xmlPath && m.xmlPath.trim());
  }

  // Helper to check component mapping from header string (e.g., "PID 5" or "GT1 3")
  hasMappingForComponentFromHeader(header: string, componentIndex: number): boolean {
    if (!header || !componentIndex) return false;
    const parts = header.trim().split(/\s+/);
    if (parts.length < 2) return false;
    const segment = parts[0];
    const fieldIndex = parseInt(parts[1]);
    if (isNaN(fieldIndex)) return false;
    // Use the main hasMappingForComponent which now handles OBX conditional mappings and checks cache first
    return this.hasMappingForComponent(segment, fieldIndex, componentIndex);
  }

  private async loadAliasLookup(): Promise<void> {
    try {
      const csv = await this.http.get('assets/XPathAliasLookup.csv', { responseType: 'text' }).toPromise();
      if (csv) {
        const lines = csv.split('\n').filter(line => line.trim() && !line.startsWith('XPath'));
        this.aliasLookup.clear();
        for (const line of lines) {
          const [xpath, alias] = line.split(',').map(s => s.trim());
          if (xpath && alias) {
            this.aliasLookup.set(xpath, alias);
          }
        }
      }
    } catch (err) {
      console.warn('Failed to load alias lookup CSV, using fallback', err);
    }
  }

  private async loadAvailableAliases(): Promise<void> {
    try {
      const csv = await this.http.get('assets/XPathAliasLookup.csv', { responseType: 'text' }).toPromise();
      if (csv) {
        const lines = csv.split('\n').filter(line => line.trim() && !line.startsWith('XPath'));
        this.availableAliases = [];
        for (const line of lines) {
          const [xpath, alias] = line.split(',').map(s => s.trim());
          if (xpath && alias) {
            this.availableAliases.push({ path: xpath, alias: alias });
          }
        }
        // Sort by alias name for easier selection
        this.availableAliases.sort((a, b) => a.alias.localeCompare(b.alias));
      }
    } catch (err) {
      console.warn('Failed to load available aliases', err);
    }
  }

  /**
   * Loads expression functions configuration from the backend API.
   * These functions are used in the expression builder for creating custom mappings.
   */
  private async loadExpressionFunctions(): Promise<void> {
    if (this.expressionFunctionsLoaded) {
      return; // Already loaded
    }
    
    try {
      const response = await this.commonService.getHL7ExpressionFunctions().toPromise();
      if (response) {
        this.expressionFunctionsConfig = response;
        this.expressionFunctionsLoaded = true;
        console.log('Expression functions loaded:', this.expressionFunctionsConfig);
      }
    } catch (err) {
      console.warn('Failed to load expression functions', err);
      // Set a default empty config to prevent repeated load attempts
      this.expressionFunctionsConfig = { functions: [], dateFormats: [], routeDetails: [], headerDetails: [], messageBodyDetails: [] };
      this.expressionFunctionsLoaded = true;
    }
  }

  getAliasForMapping(xmlPath: string): string {
    if (!xmlPath) return '';
    
    // Normalize: remove duplicate mappingData/ if present
    let normalized = xmlPath.replace(/^mappingData\/mappingData\//, 'mappingData/');
    
    // Try exact match
    if (this.aliasLookup.has(normalized)) {
      return this.aliasLookup.get(normalized)!;
    }
    if (this.aliasLookup.has(xmlPath)) {
      return this.aliasLookup.get(xmlPath)!;
    }
    
    // Try case-insensitive match
    for (const [key, value] of this.aliasLookup.entries()) {
      if (key.toLowerCase() === normalized.toLowerCase() || key.toLowerCase() === xmlPath.toLowerCase()) {
        return value;
      }
    }
    
    // Try partial match
    for (const [key, value] of this.aliasLookup.entries()) {
      if (normalized.endsWith(key) || xmlPath.endsWith(key)) {
        return value;
      }
    }
    
    // Fallback to last meaningful part
    const parts = xmlPath.split('/');
    return parts[parts.length - 1] || xmlPath;
  }

  /**
   * Gets tooltip text for a field showing where it's mapped to (with aliases)
   * CHANGED: Now shows all mapped values on hover when isFromInterface is true
   */
  getFieldMappingTooltip(objsegment: any): string {
    if (!objsegment || !objsegment.isMapped || !objsegment.mappingInfo || objsegment.mappingInfo.length === 0) {
      return '';
    }
    
    // CHANGED: Show all mappings when isFromInterface is true
    // REVERT: To show only first mapping, replace this section with:
    // const firstMapping = objsegment.mappingInfo[0];
    // if (firstMapping.alias && firstMapping.alias !== firstMapping.xmlPath) {
    //   return `${firstMapping.alias}\n(${firstMapping.xmlPath})`;
    // } else {
    //   return firstMapping.xmlPath;
    // }
    
    const tooltips: string[] = [];
    for (const mapping of objsegment.mappingInfo) {
      if (mapping.alias && mapping.alias !== mapping.xmlPath) {
        // Show only alias (not XPath) when available
        tooltips.push(mapping.alias);
      } else {
        // Show XMLPath if no alias (fallback)
        tooltips.push(mapping.xmlPath);
      }
    }
    
    return tooltips.join('\n\n');
  }

  // Resolve variable references in conditions to show mapped attributes instead of variable xpaths
  resolveConditionWithVariables(condition: string): string {
    if (!condition || !this.mappingsRaw || this.mappingsRaw.length === 0) return condition || '';
    
    // Pattern to match variable references like $variableName
    const variablePattern = /\$(\w+)/g;
    let resolved = condition;
    let match;
    
    while ((match = variablePattern.exec(condition)) !== null) {
      const varName = match[1]; // e.g., "spin"
      const varRef = match[0]; // e.g., "$spin"
      
      // Try to find the HL7 path that this variable might reference
      // Variables typically reference HL7 paths like "HL7Message/OBR/OBR.37/OBR.37.1"
      // We need to find what XML path that HL7 path maps to
      // Since we don't have direct access to variable definitions, we'll look for common patterns
      
      // Common variable patterns based on MappedXML structure:
      // $spin -> OBR.37.1 -> find mapping for OBR.37.1
      // $orderno -> OBR.2.1 -> find mapping for OBR.2.1
      // $clinichis -> DG1.4.1 -> find mapping for DG1.4.1
      
      let hl7PathToFind = '';
      if (varName.toLowerCase() === 'spin') {
        hl7PathToFind = 'OBR.37.1';
      } else if (varName.toLowerCase() === 'orderno') {
        hl7PathToFind = 'OBR.2.1';
      } else if (varName.toLowerCase() === 'clinichis') {
        hl7PathToFind = 'DG1.4.1';
      }
      
      if (hl7PathToFind) {
        // Find the mapping for this HL7 path
        const mapping = this.mappingsRaw.find(m => {
          const path = (m.HL7Path || '').toUpperCase();
          return path.includes(hl7PathToFind.toUpperCase());
        });
        
        if (mapping && mapping.XMLPath) {
          // Replace variable reference with the mapped attribute alias
          const alias = this.getAliasForMapping(mapping.XMLPath);
          resolved = resolved.replace(varRef, alias || mapping.XMLPath);
        }
      }
    }
    
    return resolved;
  }

  /**
   * CHANGED: Gets a short description of what a mapping method/function does
   * Used to display helpful information about conditions
   * REVERT: Remove this method and its usage in HTML to revert
   */
  getMethodDescription(condition: string): string {
    if (!condition || !this.isFromInterface) return '';
    
    const conditionUpper = condition.toUpperCase();
    const descriptions: string[] = [];
    
    // Check for common mapping functions
    if (conditionUpper.includes('GETMAPPINGVALUE')) {
      descriptions.push('GetMappingValue: Maps code values using lookup table');
    }
    if (conditionUpper.includes('GETCONVERTDATETIME')) {
      descriptions.push('GetConvertDateTime: Converts date format (e.g., yyyyMMdd to MM/dd/yyyy)');
    }
    if (conditionUpper.includes('GETREPLACE')) {
      descriptions.push('GetReplace: Replaces characters in string (e.g., ~ to ;)');
    }
    if (conditionUpper.includes('CONCATNODEATTRIBUTES')) {
      descriptions.push('ConcatNodeAttributes: Concatenates multiple node values');
    }
    if (conditionUpper.includes('COUNT(')) {
      descriptions.push('count(): Counts matching segments');
    }
    if (conditionUpper.includes('CONCAT(')) {
      descriptions.push('concat(): Joins values with separator');
    }
    if (conditionUpper.includes('GETTRIM')) {
      descriptions.push('GetTrim: Removes leading/trailing whitespace');
    }
    if (conditionUpper.includes('GETUPPERCASE')) {
      descriptions.push('GetUpperCase: Converts text to uppercase');
    }
    if (conditionUpper.includes('GETSPLIT')) {
      descriptions.push('GetSplit: Splits string into parts');
    }
    if (conditionUpper.includes('GETONLYNUMERICS')) {
      descriptions.push('GetOnlyNumerics: Extracts only numeric characters');
    }
    if (conditionUpper.includes('GETALPHANUMERICVALUES')) {
      descriptions.push('GetAlphaNumericValues: Extracts alphanumeric characters');
    }
    if (conditionUpper.includes('GETAGE')) {
      descriptions.push('GetAge: Calculates age from date');
    }
    if (conditionUpper.includes('GETPARSEDATE')) {
      descriptions.push('GetParseDate: Parses date string');
    }
    if (conditionUpper.includes('GETVALUEFORREGEXPRESSION')) {
      descriptions.push('GetValueForRegExpression: Extracts value using regex');
    }
    if (conditionUpper.includes('CREATENTEFORSPLITVALUE')) {
      descriptions.push('CreateNTEForSplitValue: Creates NTE segments from split values');
    }
    if (conditionUpper.includes('CREATENTEFORGIVENLENGTH')) {
      descriptions.push('CreateNTEForGivenLength: Creates NTE segments for fixed length');
    }
    if (conditionUpper.includes('CREATESEGMENTFORSPLITVALUE')) {
      descriptions.push('CreateSegmentForSplitValue: Creates segments from split values');
    }
    
    return descriptions.length > 0 ? descriptions.join(' | ') : '';
  }

  /**
   * CHANGED: Gets condition display text with method descriptions
   * REVERT: Replace usage with resolveConditionWithVariables() to revert
   */
  getConditionDisplay(condition: string): string {
    if (!condition) return '';
    
    const resolved = this.resolveConditionWithVariables(condition);
    const methodDesc = this.getMethodDescription(condition);
    
    if (methodDesc && this.isFromInterface) {
      return `${resolved}\n\n[${methodDesc}]`;
    }
    
    return resolved;
  }

  async copyXPathOnDoubleClick(xmlPath: string, event?: Event): Promise<void> {
    if (!xmlPath) return;
    if (event) {
      event.stopPropagation(); // Prevent row double-click from firing
    }
    try {
      await copyToClipboard(xmlPath);
      this.toastr.success('XPath copied to clipboard!', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 2000,
      });
    } catch (err) {
      this.toastr.error('Failed to copy XPath', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 2000,
      });
    }
  }

  dosegmentvalidate(dataitem: any) {
    if (dataitem.segtype == "NOTEMPTY" && dataitem.segvalue.length == 0) {
      return "[Mandatory]"
    }
    return "";
  }


  clearvalues() {
    this.SelectedsegComponentfileds = [];
    this.SelectedSubsegComponentfileds = [];
    this.segmentcomponentheader = 'Name';
    this.segmentSubcomponentheader = 'Name';
  }

  Yindex: number = -1;
  //textarea element

  selectedSegment: string
  filedIndexs = 0
  async doEditorKeyUp(SelectedsegmentContent: string, filedIndex) {
    if (this.filedIndexs != filedIndex) {
      this.valuetoHighlight = ''
    }
    this.filedIndexs = filedIndex

    let data = this.inputdata.split("\n")
    SelectedsegmentContent = data[filedIndex]
    this.selectedSegment = ""
    // if (SelectedsegmentContent.includes("mark")) {
    //   SelectedsegmentContent = SelectedsegmentContent.replace("</mark>", "")
    //   SelectedsegmentContent = SelectedsegmentContent.replace("<mark>", "")
    // }

    this.selectedSegment = SelectedsegmentContent;
    await this.Parseinputselecteddata(SelectedsegmentContent);

    this.splittedContent = this.inputdata.split("\n");

    if (this.valuetoHighlight != "" && this.highlightSegment == SelectedsegmentContent) {
      this.highLightFunction(this.valuetoHighlight, this.HeighlightIndex, this.segIndexs)

    }
    else {
      this.rowClicked = -1
      this.rowClickedSub = -1
      this.SelectedSubsegComponentfileds = []
      this.SelectedsegComponentfileds = []
      this.segmentcomponentheader ='Name';
      this.segmentSubcomponentheader='Name';
    }

    this.getfieldsbyheaders(this.segmentheader);

  }


  setselectionrange(position: any) {
    // const textarea = document.querySelector('textarea');

    const textarea: HTMLTextAreaElement = this.myinput.nativeElement;

    if (textarea != null) {
      var b = this.inputdata.split("\n");
      for (var i = 0; i < b.length; i++) {
        b[i] = b[i].replace('\n', '');
      }

      var c = 0, d = 0;
      for (var i = 0; i < b.length; i++) {

        if (i != position) {
          d += b[i].length + 1
        }
        else {
          break;
        }
      }
      textarea.focus();
      textarea.setSelectionRange(d, d + this.inputdata.split("\n")[position].length);
    }
  }

  getselectedpositions(selectionStart: any) {
    var a = selectionStart;
    var b = this.inputdata.split("\n");
    var c = 0, d = 0;
    for (var i = 0; i < b.length; i++) {
      if (d + b[i].length < a) {
        d += b[i].length + 1
        c = i;
      }
      else {
        c = i;
        break
      }
    }
    // for (var a = selectionStart, b = this.inputdata.split("\n"), c = 0, d = 0; d + b[c].length < a;) d += b[c].length + 1, c++;
    return c
  };
  doEditorKeychange(event: any) {

    console.log("inside doEditorKeychange")
    var SelectedsegmentContent = this.inputdata.split("\n")[1];
    this.Parseinputselecteddata(SelectedsegmentContent);
  }

  async onPaste(item: any) {
    console.log("inside onPaste ")

    await this.clearAll();
    this.Parseinputselecteddata(item);
    await this.focus();
  }
  doDropMessage(item: any) {

    console.log("Inside doDropMessage")
    console.log("doDropMessage::", item);
  }

  getCursorX(selectionStart: any) {
    for (var a = this.inputdata.split("\n"), b = 0, c = this.getCursorY(selectionStart), d = 0; d < c; d++) b += a[d].length + 1;
    return selectionStart - b
  };
  getCursorY(selectionStart: any) {
    for (var a = selectionStart, b = this.inputdata.split("\n"), c = 0, d = 0; d + b[c].length < a;) d += b[c].length + 1, c++;
    return c
  };

  @ViewChild('myInput', { static: false }) myinput!: ElementRef<any>;

  async focus() {
    if (this.myinput && this.myinput.nativeElement && typeof this.myinput.nativeElement.focus === 'function') {
      this.myinput.nativeElement.focus();
    }
  }

  //page menu functions
  async clearAll() {
    this.inputdata = "";
    this.segments = [];
    this.segmentheader = 'Name';
    this.displaynamesegheader = 'Name';
    this.rowClicked = -1;
    this.rowClickedSub = -1;
    this.segmentcomponentheader = 'Name';
    this.SelectedsegComponentfileds = [];
    this.segmentSubcomponentheader = 'Name';
    this.SelectedSubsegComponentfileds = [];
    this.Yindex = -1;
  }

  async paste() {
    await this.clearAll();
    this.inputdata = await (await navigator.clipboard.readText()).trim();
  }
  copyMessage(val: string, type: string) {

    if (val) {
      copyToClipboard(val);




      this.toastr.success(' Copied to clipboard !', '', {
        positionClass: "toast-bottom-right",
        timeOut: 500,
      });

    }
  }

  trigger() {
    let element = document.getElementById('upload_file') as HTMLInputElement;
    element.click();
  }

  onChange(file: any) {
    var file = file.files[0];
    var reader = new FileReader();
    reader.onload = async (e: any) => {
      this.inputdata = (e && e.target) ? e.target.result : '';
      // Ensure the full HL7 appears immediately
      this.splittedContent = (this.inputdata || '').split("\n");
      // Initialize with original content until preprocessing is done (sanitized)
      this.splittedContentWithHighlights = this.splittedContent.map(line => 
        this.sanitizer.bypassSecurityTrustHtml(line)
      );
      // Re-parse and render viewer content
      await this.Parseinputselecteddata(this.inputdata);
      if (this.segmentheader && this.segmentheader !== 'Name') {
        await this.getfieldsbyheaders(this.segmentheader);
      }
      // Refresh mappings for the newly loaded HL7
      try {
        if (this.isFromInterface && this.interfaceId && this.processorAgentId) {
          await this.loadMappings(this.inputdata, this.interfaceId, this.processorAgentId);
        } else {
          await this.loadMappings(this.inputdata, 'default', 'default');
        }
      } catch { /* ignore */ }
    };
    reader.readAsText(file);
  }
  async DoubleClickselectsubSegmentCom(segment: any) {

    clearTimeout(this.matMenuTimer);
    this.matMenuTimer = undefined;
    await this.copyMessage(segment.segvalue, '');
    await this.focus();
  }
  matMenuTimer: any;
  async DoubleClickselectSegment(segment: any) {

    clearTimeout(this.matMenuTimer);
    this.matMenuTimer = undefined;
    await this.copyMessage(segment, '');
    await this.focus();
  }

  clickedMe() {
    if (!this.matMenuTimer) return;
  }
  async DoubleClickselectSegmentCom(dataitem: any) {

    clearTimeout(this.matMenuTimer);
    this.matMenuTimer = undefined;
    await this.copyMessage(dataitem.segvalue, '');
    await this.focus();
  }
  getspechelemnt() {
    this.VASpec[this.segmentheader]
  }
  getTitle(objdata: any) {
    return (objdata == 'Mandatory' || objdata == '') ? 'Value could not be empty' : 'The expected format is ' + objdata;
  }

  async getfileContentById(fileid: any) {
    this.ngxUiLoaderService.start();
    (await this.myServices.getfilecontent(fileid)).subscribe({
      next: data => {
        // const file = new window.Blob([data], { type: 'application/octet-stream' });
        // const downloadAncher = document.createElement("a");
        // const fileURL = URL.createObjectURL(file);
        // downloadAncher.href = fileURL;
        // downloadAncher.download = fileid;
        // downloadAncher.click();
        this.inputdata = data;
        // var SelectedsegmentContent = this.inputdata.split("\n")[0];
        // this.Parseinputselecteddata(SelectedsegmentContent);
        // const textarea = document.querySelector('textarea');
        // if (textarea != null) {
        //   textarea.setSelectionRange(0, this.inputdata.split("\n")[0].length);
        // }
        if (this.checkJsonValidity(data)) {
          this.noofrows = 10;
          this.getfileContentById(JSON.parse(data).fileid)
          this.ngxUiLoaderService.stop();
        }
        this.noofrows = 10;
        this.myServices.updatessoStatus(true);
        this.ngxUiLoaderService.stop();
      },
      error: error => {
        this.ngxUiLoaderService.stop();
        console.log('Failed to retrieve the file contents' + error);
      }
    });
  }

  checkJsonValidity(datastring: any) {
    try {
      JSON.parse(datastring);
      return true;
    } catch (error) {
      return false;
    }
  }
  closeEmail() {
    this.activeModal.close();
  }
  highlightedText: string
  valuetoHighlight: any
  highlightSegment: any
  HeighlightIndex: any
  textHighlight(text, Occ, segmentIndexToGetFields, highlightIndex) {
    this.valuetoHighlight = text;
    // Regenerate splittedContent from clean inputdata to remove any previous <mark> tags
    this.splittedContent = this.inputdata.split("\n");
    // Remove all <mark> and </mark> tags from the segment (using regex for global replacement)
    if (this.splittedContent[segmentIndexToGetFields] && this.splittedContent[segmentIndexToGetFields].includes("mark")) {
      this.splittedContent[segmentIndexToGetFields] = this.splittedContent[segmentIndexToGetFields].replace(/<\/?mark>/g, "");
    }
    this.selectedSegment = this.splittedContent[segmentIndexToGetFields];
    this.highlightSegment = this.selectedSegment;
    let count = 0;
    let index = -1;
    let splittedcontent = this.selectedSegment.split("|");
    while (count < Occ) {

      index = this.selectedSegment.indexOf(text, index + 1);
      if (index === -1) break;
      count++;
    }
    if (index >= 0) {
      let HTML = ""
      const highlightedText = `<mark>${text}</mark>`;
      if (this.splittedContent[segmentIndexToGetFields].startsWith("MSH")) {
        highlightIndex = highlightIndex - 1
      }

      if (text == "MSH" && highlightIndex == 0) {
        const highlightedText = `<mark>${"|"}</mark>`;
        this.selectedSegment = this.selectedSegment.substring(0, 3) + highlightedText + this.selectedSegment.substring(5, this.selectedSegment.length)
      } else {


        for (let index = 0; index < splittedcontent.length; index++) {

          if (splittedcontent[index] == text && index == highlightIndex) {
            HTML = HTML + highlightedText + "|"
          }
          else {
            HTML = HTML + splittedcontent[index] + "|";
          }


          //const updatedHTML = this.selectedSegment.substring(0, index) +highlightedText +this.selectedSegment.substring(index + text.length);


        }
        this.selectedSegment = HTML.slice(0, -1);
      }
      // alongwith mark tag
      // for (let index = 0; index < this.splittedContent.length; index++) {
      //   if (this.splittedContent[index] == segment[0]) {
      //     this.segmentIndexToGetFields[index] = this.selectedSegment;
      //     break;
      //   }
      // }
      this.splittedContent[segmentIndexToGetFields] = this.selectedSegment

    }
  }

  isPartOfWord(index: number, length: number, segment: string): boolean {
    const prevChar = segment[index - 1];
    const nextChar = segment[index + length];
    return (prevChar && prevChar.match(/[a-zA-Z]/) !== null) || (nextChar && nextChar.match(/[a-zA-Z]/) !== null);
  }
  toStoreAccruence: any = []
  arrayvalues: any = []
  llarrayvalues: any[]
  segIndexs: any
  highLightFunction(item: string, idex: number, segIndex: any) {
    this.HeighlightIndex = idex;
    this.valuetoHighlight = item;
    this.segIndexs = segIndex


    let Occ = this.addObjectIfMissing(this.toStoreAccruence, idex, item, this.fieldvalues);

    this.textHighlight(item, Occ, this.filedIndexs, segIndex)
  }

  // Check if editing is allowed for a subcomponent
  canEditMapping(objsubsegment: any): boolean {
    if (!this.isFromInterface) {
      return false; // Only allow editing when isFromInterface is true
    }
    
    if (!objsubsegment || !objsubsegment.segindex) {
      return false;
    }
    
    // Get mappings for this subcomponent
    const mappings = this.getMappingsForSubcomponent(objsubsegment);
    
    // If there are mappings, check if any of them allow editing
    // If no mappings exist, we can still allow editing (for adding new mappings)
    if (mappings.length > 0) {
      // Check if any mapping allows editing (all must allow editing for consistency)
      return mappings.every(m => m.canEdit !== false);
    }
    
    // If no mappings, check the segment header to determine if editing is allowed
    const segHeader = (this.segmentcomponentheader || '').split(' ')[0];
    const restrictedSegments = ['OBR', 'OBX', 'NTE'];
    return !restrictedSegments.includes(segHeader?.toUpperCase());
  }

  // Mapping modal methods
  async openMappingModal(objsubsegment: any, event?: Event): Promise<void> {
    console.log('openMappingModal called', { objsubsegment });
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    
    if (!this.isFromInterface || !this.interfaceId || !this.processorAgentId) {
      this.toastr.warning('Mapping can only be edited when viewing from an interface', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }
    
    const segHeader = (this.segmentcomponentheader || '').split(' ')[0];
    const hl7Path = this.buildHl7Path(segHeader, objsubsegment.segindex);
    
    // Load filtered mappings from backend if available
    if (this.isFromInterface && this.interfaceId && this.processorAgentId) {
      await this.loadFilteredMappings(objsubsegment.segindex);
    }
    
    // Load available aliases
    this.loadAvailableAliases();
    
    // Load expression functions for the expression builder
    await this.loadExpressionFunctions();
    
    const currentMappings = this.getMappingsForSubcomponent(objsubsegment);
    
    const dialogData: AddMappingDialogData = {
      subcomponent: objsubsegment,
      hl7Path: hl7Path,
      currentMappings: currentMappings,
      availableAliases: this.availableAliases,
      isFromInterface: this.isFromInterface,
      expressionFunctionsConfig: this.expressionFunctionsConfig,
      getAliasForMapping: (xmlPath: string) => this.getAliasForMapping(xmlPath),
      getPendingChangeForMapping: (segIndex: string, xmlPath: string, hl7Path: string) => 
        this.getPendingChangeForMapping(segIndex, xmlPath, hl7Path),
      stageMappingChange: (segIndex: string, action: 'add' | 'delete' | 'update', mapping: { xmlPath: string, condition: string, hl7Path: string }, originalMapping?: { xmlPath: string, condition: string, hl7Path: string }) => 
        this.stageMappingChange(segIndex, action, mapping, originalMapping),
      removePendingChange: (segIndex: string, changeId: string) => 
        this.removePendingChange(segIndex, changeId),
      deleteMapping: async (mappingToDelete: { xmlPath: string, condition: string }) => {
        // Directly stage the delete using the mapping object, avoiding index issues
        const segIndex = objsubsegment.segindex;
        const deleteMappingObj = {
          hl7Path: hl7Path,
          xmlPath: mappingToDelete.xmlPath,
          condition: mappingToDelete.condition || ''
        };
        
        // Stage the deletion
        this.stageMappingChange(segIndex, 'delete', deleteMappingObj);
        
        // Show success message
        this.toastr.success('Deletion staged. Click "Save All" to apply.', '', {
          positionClass: 'toast-bottom-right',
          timeOut: 2000,
        });
      },
      getMappingsForSubcomponent: (subcomponent: any) => 
        this.getMappingsForSubcomponent(subcomponent),
      getConditionDisplay: (condition: string) => 
        this.getConditionDisplay ? this.getConditionDisplay(condition) : condition,
      getMethodDescription: (condition: string) => 
        this.getMethodDescription ? this.getMethodDescription(condition) : ''
    };
    
    const dialogRef = this.dialog.open(AddMappingDialogComponent, {
      maxWidth: '90vw',
      width: '80%',
      maxHeight: '90vh',
      data: dialogData,
      disableClose: false,
      panelClass: 'confirm-dialog-panel'
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.mappings) {
        // Refresh mappings if needed
        // The dialog handles staging internally, so we just need to refresh the view
        this.cdr.markForCheck();
      }
    });
  }

  closeMappingModal(): void {
    console.log('closeMappingModal called');
    this.showMappingModal = false;
    this.currentSubcomponent = null;
    this.currentHl7Path = '';
    this.currentMappings = [];
    this.editingMappingIndex = null;
    this.isAddingMapping = false;
    this.selectedAliasPath = '';
    this.mappingCondition = '';
    
    // Restore body scroll
    document.body.style.overflow = '';
  }

  // CHANGED: Edit functionality removed from UI but method kept for easy revert
  // REVERT: Uncomment Edit button in HTML and this method will work again
  editMapping(mapping: { xmlPath: string, condition: string, canEdit?: boolean }, index: number): void {
    if (!mapping) return;
    console.log('editMapping called', { mapping, index });
    this.editingMappingIndex = index;
    this.isAddingMapping = false;
    this.selectedAliasPath = mapping.xmlPath || '';
    this.mappingCondition = mapping.condition || '';
  }

  addNewMapping(): void {
    console.log('addNewMapping called');
    this.isAddingMapping = true;
    this.editingMappingIndex = null;
    this.selectedAliasPath = '';
    this.mappingCondition = '';
  }

  cancelEditMapping(): void {
    console.log('cancelEditMapping called');
    this.editingMappingIndex = null;
    this.isAddingMapping = false;
    this.selectedAliasPath = '';
    this.mappingCondition = '';
  }

  onAliasChange(): void {
    // Optional: Add any logic when alias selection changes
  }

  onModalBackdropClick(event: Event): void {
    // Prevent backdrop clicks from closing modal - keep it sticky
    if (event.target === event.currentTarget) {
      event.stopPropagation();
    }
  }

  async saveMapping(): Promise<void> {
    console.log('saveMapping called', { selectedAliasPath: this.selectedAliasPath, currentSubcomponent: this.currentSubcomponent, currentHl7Path: this.currentHl7Path });
    if (!this.selectedAliasPath || !this.currentSubcomponent || !this.currentHl7Path) {
      this.toastr.error('Please select an alias to map to', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }

    if (!this.isFromInterface || !this.interfaceId || !this.processorAgentId) {
      this.toastr.warning('Mapping can only be saved when viewing from an interface', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }

    // CHANGED: Stage change instead of immediate save for batch editing
    // REVERT: Uncomment the try-catch block below and remove staging logic to revert
    const segIndex = this.currentSubcomponent.segindex;
    const mapping = {
      hl7Path: this.currentHl7Path,
      xmlPath: this.selectedAliasPath,
      condition: this.mappingCondition || ''
    };

    // Check if this is an update (editing existing mapping)
    if (this.editingMappingIndex !== null && this.currentMappings[this.editingMappingIndex]) {
      const originalMapping = this.currentMappings[this.editingMappingIndex];
      const original = {
        hl7Path: this.currentHl7Path,
        xmlPath: originalMapping.xmlPath,
        condition: originalMapping.condition || ''
      };
      
      // Remove any existing pending change for this mapping first
      const existingPending = this.getPendingChangeForMapping(segIndex, originalMapping.xmlPath, this.currentHl7Path);
      if (existingPending) {
        this.removePendingChange(segIndex, existingPending.id);
      }
      
      // Stage as update
      this.stageMappingChange(segIndex, 'update', mapping, original);
      this.toastr.success('Change staged. Click "Save All" to apply.', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 2000,
      });
    } else {
      // Stage as add
      this.stageMappingChange(segIndex, 'add', mapping);
      this.toastr.success('Change staged. Click "Save All" to apply.', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 2000,
      });
    }

    // Update current mappings display to show staged changes
    this.currentMappings = this.getMappingsForSubcomponent(this.currentSubcomponent);
    
    // Reset form
    this.cancelEditMapping();

    // REVERT: Uncomment below to restore immediate save behavior
    /*
    try {
      // CHANGED: Note - Repeatable nodes are automatically handled by the backend
      // The backend detects if the XMLPath is inside a _RepeatableNode element
      // and sets IsRepeatable flag accordingly. No additional parameters needed.
      const mappingData = {
        hl7Path: this.currentHl7Path,
        xmlPath: this.selectedAliasPath,
        condition: this.mappingCondition || '',
        interfaceId: this.interfaceId,
        processorAgentId: this.processorAgentId,
        hl7Raw: this.inputdata
      };

      // Call API to save mapping
      const response = await this.commonService.saveHL7Mapping(mappingData).toPromise();
      
      if (response) {
        this.toastr.success('Mapping saved successfully', '', {
          positionClass: 'toast-bottom-right',
          timeOut: 2000,
        });

        // Reload mappings
        await this.loadMappings(this.inputdata, this.interfaceId, this.processorAgentId);
        
        // Clear filtered cache to force reload of filtered mappings
        this.filteredMappingsCache.clear();
        this.loadingMappings.clear();
        
        // Reload filtered mappings for current subcomponent
        if (this.currentSubcomponent && this.isFromInterface && this.interfaceId && this.processorAgentId) {
          await this.loadFilteredMappings(this.currentSubcomponent.segindex);
        }
        
        // Update current mappings display
        this.currentMappings = this.getMappingsForSubcomponent(this.currentSubcomponent);
        
        // Reset form
        this.cancelEditMapping();
      }
    } catch (error) {
      console.error('Error saving mapping:', error);
      this.toastr.error('Failed to save mapping', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
    }
    */
  }

  async deleteMapping(index: number): Promise<void> {
    console.log('deleteMapping called', { index });
    if (!this.isFromInterface || !this.interfaceId || !this.processorAgentId) {
      this.toastr.warning('Mapping can only be deleted when viewing from an interface', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }

    const mapping = this.currentMappings[index];
    if (!mapping) return;

    if (!confirm(`Stage deletion of mapping to "${this.getAliasForMapping(mapping.xmlPath)}"?\n\nClick "Save All" to apply.`)) {
      return;
    }

    // CHANGED: Stage deletion instead of immediate delete for batch editing
    // REVERT: Uncomment the try-catch block below and remove staging logic to revert
    const segIndex = this.currentSubcomponent.segindex;
    const deleteMapping = {
      hl7Path: this.currentHl7Path,
      xmlPath: mapping.xmlPath,
      condition: mapping.condition || ''
    };

    this.stageMappingChange(segIndex, 'delete', deleteMapping);
    this.toastr.success('Deletion staged. Click "Save All" to apply.', '', {
      positionClass: 'toast-bottom-right',
      timeOut: 2000,
    });

    // Update current mappings display to show staged changes
    this.currentMappings = this.getMappingsForSubcomponent(this.currentSubcomponent);

    // REVERT: Uncomment below to restore immediate delete behavior
    /*
    try {
      const deleteData = {
        hl7Path: this.currentHl7Path,
        xmlPath: mapping.xmlPath,
        condition: mapping.condition || '',
        interfaceId: this.interfaceId,
        processorAgentId: this.processorAgentId
      };

      // Call API to delete mapping
      const response = await this.commonService.deleteHL7Mapping(deleteData).toPromise();
      
      if (response) {
        this.toastr.success('Mapping deleted successfully', '', {
          positionClass: 'toast-bottom-right',
          timeOut: 2000,
        });

        // Reload mappings
        await this.loadMappings(this.inputdata, this.interfaceId, this.processorAgentId);
        
        // Clear filtered cache to force reload of filtered mappings
        this.filteredMappingsCache.clear();
        this.loadingMappings.clear();
        
        // Reload filtered mappings for current subcomponent
        if (this.currentSubcomponent && this.isFromInterface && this.interfaceId && this.processorAgentId) {
          await this.loadFilteredMappings(this.currentSubcomponent.segindex);
        }
        
        // Update current mappings display
        this.currentMappings = this.getMappingsForSubcomponent(this.currentSubcomponent);
      }
    } catch (error) {
      console.error('Error deleting mapping:', error);
      this.toastr.error('Failed to delete mapping', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
    }
    */
  }

  addObjectIfMissing(occurancebook, index, itemName, arrayofFields) {
    const foundIndex = occurancebook.findIndex(item => item['name'] == itemName);

    if (foundIndex == -1) {
      const container = { name: itemName, indexes: [index] };
      occurancebook.push(container);

      this.arrayvalues = occurancebook[occurancebook.findIndex(item => item['name'] == itemName)];
      this.llarrayvalues = this.arrayvalues['indexes'];

      for (let index2 = 0; index2 < arrayofFields.length; index2++) {
        if (arrayofFields[index2].segvalue == itemName) {
          if (!this.llarrayvalues.includes(index2)) {
            this.llarrayvalues.push(index2);
            this.llarrayvalues.sort((a, b) => a - b);
          }
        }

      }
    }
    return this.llarrayvalues.indexOf(index) + 1;
  }

  async downloadMappingExcel(): Promise<void> {
    if (!this.isFromInterface || !this.interfaceId || !this.processorAgentId || !this.inputdata) {
      this.toastr.warning('Missing required information to download mappings', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }

    try {
      this.ngxUiLoaderService.start();
      const blob = await this.commonService.downloadMappingExcel(
        this.inputdata,
        this.interfaceId,
        this.processorAgentId
      ).toPromise();

      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `HL7_Mappings_${new Date().toISOString().replace(/[:.]/g, '-')}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.toastr.success('Excel file downloaded successfully', '', {
          positionClass: 'toast-bottom-right',
          timeOut: 2000,
        });
      }
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.toastr.error('Failed to download Excel file', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
    } finally {
      this.ngxUiLoaderService.stop();
    }
  }

  // CHANGED: Batch editing - Pending changes management methods
  // REVERT: Remove these methods to revert to individual save/delete
  stageMappingChange(segIndex: string, action: 'add' | 'delete' | 'update', mapping: { xmlPath: string, condition: string, hl7Path: string }, originalMapping?: { xmlPath: string, condition: string, hl7Path: string }): void {
    if (!this.isFromInterface) return;
    
    if (!this.pendingChanges.has(segIndex)) {
      this.pendingChanges.set(segIndex, []);
    }
    
    const changeId = `${segIndex}_${action}_${Date.now()}_${Math.random()}`;
    const changes = this.pendingChanges.get(segIndex)!;
    
    // For updates, check if there's already a pending change for this mapping and replace it
    if (action === 'update' && originalMapping) {
      const existingIndex = changes.findIndex(c => 
        c.action === 'update' && 
        c.originalMapping?.xmlPath === originalMapping.xmlPath &&
        c.originalMapping?.hl7Path === originalMapping.hl7Path
      );
      if (existingIndex >= 0) {
        changes[existingIndex] = {
          action,
          mapping,
          originalMapping,
          id: changes[existingIndex].id
        };
        this.cdr.markForCheck();
        return;
      }
    }
    
    // For deletes, remove any pending adds/updates for the same mapping
    if (action === 'delete') {
      const filtered = changes.filter(c => 
        !(c.action === 'add' && c.mapping.xmlPath === mapping.xmlPath && c.mapping.hl7Path === mapping.hl7Path) &&
        !(c.action === 'update' && c.mapping.xmlPath === mapping.xmlPath && c.mapping.hl7Path === mapping.hl7Path)
      );
      // Add the delete action to the filtered array before setting it back
      filtered.push({
        action,
        mapping,
        originalMapping,
        id: changeId
      });
      // Set the updated array (with delete) back to the Map
      this.pendingChanges.set(segIndex, filtered);
      this.cdr.markForCheck();
      return;
    }
    
    // For add/update actions, push to the changes array
    changes.push({
      action,
      mapping,
      originalMapping,
      id: changeId
    });
    
    this.cdr.markForCheck();
  }

  removePendingChange(segIndex: string, changeId: string): void {
    if (!this.isFromInterface) return;
    
    const changes = this.pendingChanges.get(segIndex);
    if (!changes) return;
    
    const index = changes.findIndex(c => c.id === changeId);
    if (index >= 0) {
      changes.splice(index, 1);
      if (changes.length === 0) {
        this.pendingChanges.delete(segIndex);
      }
      this.cdr.markForCheck();
    }
  }

  clearAllPendingChanges(): void {
    if (!this.isFromInterface) return;
    
    this.pendingChanges.clear();
    this.cdr.markForCheck();
  }

  getPendingChangesCount(): number {
    if (!this.isFromInterface) return 0;
    
    let count = 0;
    this.pendingChanges.forEach(changes => {
      count += changes.length;
    });
    return count;
  }

  hasPendingChanges(): boolean {
    if (!this.isFromInterface) return false;
    return this.pendingChanges.size > 0;
  }

  hasPendingChangesForSegIndex(segIndex: string): boolean {
    if (!this.isFromInterface) return false;
    const changes = this.pendingChanges.get(segIndex);
    return changes ? changes.length > 0 : false;
  }

  getPendingChangeForMapping(segIndex: string, xmlPath: string, hl7Path: string): { action: string, id: string } | null {
    if (!this.isFromInterface) return null;
    
    const changes = this.pendingChanges.get(segIndex);
    if (!changes) return null;
    
    const change = changes.find(c => 
      c.mapping.xmlPath === xmlPath && c.mapping.hl7Path === hl7Path
    );
    
    return change ? { action: change.action, id: change.id } : null;
  }

  async saveAllPendingChanges(): Promise<void> {
    if (!this.isFromInterface || !this.interfaceId || !this.processorAgentId) {
      this.toastr.warning('Batch save is only available when viewing from an interface', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }

    if (!this.hasPendingChanges()) {
      this.toastr.info('No pending changes to save', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 2000,
      });
      return;
    }

    // Collect all changes into array
    const allChanges: Array<{
      action: 'add' | 'delete' | 'update',
      hl7Path: string,
      xmlPath: string,
      condition: string,
      originalMapping?: { hl7Path: string, xmlPath: string, condition: string }
    }> = [];

    this.pendingChanges.forEach((changes, segIndex) => {
      changes.forEach(change => {
        allChanges.push({
          action: change.action,
          hl7Path: change.mapping.hl7Path,
          xmlPath: change.mapping.xmlPath,
          condition: change.mapping.condition || '',
          originalMapping: change.originalMapping
        });
      });
    });

    if (allChanges.length === 0) {
      return;
    }

    try {
      this.ngxUiLoaderService.start();
      
      // Call batch save API
      const response = await this.commonService.saveBatchHL7Mappings({
        interfaceId: this.interfaceId,
        processorAgentId: this.processorAgentId,
        changes: allChanges,
        hl7Raw: this.inputdata
      }).toPromise();

      // CHANGED: Handle both camelCase (success) and PascalCase (Success) for JSON serialization compatibility
      // REVERT: Revert to original check to revert
      const isSuccess = response && (response.success || response.Success);
      
      if (isSuccess) {
        // Handle both camelCase and PascalCase for results array
        const results = response.results || response.Results || [];
        const successCount = results.filter((r: any) => r.success || r.Success).length || 0;
        const failCount = results.length - successCount;

        if (failCount === 0) {
          this.toastr.success(`All ${successCount} mapping(s) saved successfully`, '', {
            positionClass: 'toast-bottom-right',
            timeOut: 3000,
          });
        } else {
          this.toastr.warning(`${successCount} saved, ${failCount} failed. Check details.`, '', {
            positionClass: 'toast-bottom-right',
            timeOut: 5000,
          });
        }

        // Reload mappings
        await this.loadMappings(this.inputdata, this.interfaceId, this.processorAgentId);
        
        // Clear filtered cache
        this.filteredMappingsCache.clear();
        this.loadingMappings.clear();
        
        // Clear pending changes
        this.clearAllPendingChanges();
        
        // CRITICAL: Regenerate splittedContent from clean inputdata to remove any <mark> tags
        // The textHighlight method modifies splittedContent directly, so we need to refresh it
        this.splittedContent = (this.inputdata || '').split("\n");
        // Regenerate highlights with updated mappings
        this.preprocessMappingStatus();
        
        // Reload filtered mappings for current subcomponent if modal is open
        if (this.currentSubcomponent && this.isFromInterface && this.interfaceId && this.processorAgentId) {
          await this.loadFilteredMappings(this.currentSubcomponent.segindex);
          this.currentMappings = this.getMappingsForSubcomponent(this.currentSubcomponent);
        }
      } else {
        // Handle both camelCase and PascalCase for message
        const errorMessage = response?.message || response?.Message || 'Unknown error';
        this.toastr.error('Failed to save mappings', errorMessage, {
          positionClass: 'toast-bottom-right',
          timeOut: 5000,
        });
      }
    } catch (error) {
      console.error('Error saving batch mappings:', error);
      this.toastr.error('Failed to save mappings', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
    } finally {
      this.ngxUiLoaderService.stop();
      this.showSaveAllConfirmation = false;
    }
  }

  showSaveAllConfirmationDialog(): void {
    if (!this.hasPendingChanges()) {
      return;
    }
    
    let addCount = 0, deleteCount = 0, updateCount = 0;
    const affectedSegments = new Set<string>();
    const pendingChangesArray: Array<{
      segIndex: string;
      changes: Array<{
        action: 'add' | 'delete' | 'update';
        mapping: { xmlPath: string, condition: string, hl7Path: string };
        originalMapping?: { xmlPath: string, condition: string, hl7Path: string };
      }>;
    }> = [];
    
    this.pendingChanges.forEach((changes, segIndex) => {
      affectedSegments.add(segIndex);
      const segmentChanges = changes.map(change => ({
        action: change.action,
        mapping: change.mapping,
        originalMapping: change.originalMapping
      }));
      
      pendingChangesArray.push({
        segIndex: segIndex,
        changes: segmentChanges
      });
      
      changes.forEach(change => {
        if (change.action === 'add') addCount++;
        else if (change.action === 'delete') deleteCount++;
        else if (change.action === 'update') updateCount++;
      });
    });
    
    const dialogData: SaveAllConfirmationDialogData = {
      pendingChanges: pendingChangesArray,
      summary: {
        addCount: addCount,
        deleteCount: deleteCount,
        updateCount: updateCount,
        segmentCount: affectedSegments.size
      },
      getAliasForMapping: (xmlPath: string) => this.getAliasForMapping(xmlPath)
    };
    
    const dialogRef = this.dialog.open(SaveAllConfirmationDialogComponent, {
      maxWidth: '80vw',
      width: '80%',
      data: dialogData,
      disableClose: true,
      panelClass: 'confirm-dialog-panel'
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.saveAllPendingChanges();
      }
    });
  }

  // ========== Function Config Modal Methods ==========

  /**
   * Opens the function configuration modal.
   */
  openFunctionConfigModal(): void {
    // Ensure functions are loaded
    this.loadExpressionFunctions().then(() => {
      this.showFunctionConfigModal = true;
      this.cdr.markForCheck();
    });
  }

  /**
   * Closes the function configuration modal.
   */
  closeFunctionConfigModal(): void {
    this.showFunctionConfigModal = false;
    this.cancelFunctionEdit();
    this.functionSearchTerm = '';
  }

  /**
   * Filters functions based on search term.
   */
  getFilteredFunctions(): any[] {
    if (!this.expressionFunctionsConfig?.functions) return [];
    
    if (!this.functionSearchTerm) {
      return this.expressionFunctionsConfig.functions;
    }

    const term = this.functionSearchTerm.toLowerCase();
    return this.expressionFunctionsConfig.functions.filter((f: any) => 
      f.displayName?.toLowerCase().includes(term) ||
      f.name?.toLowerCase().includes(term) ||
      f.category?.toLowerCase().includes(term) ||
      f.description?.toLowerCase().includes(term)
    );
  }

  /**
   * Opens the form to add a new function.
   */
  addNewFunction(): void {
    this.isAddingFunction = true;
    this.editingFunctionIndex = null;
    this.editingFunction = { 
      name: '', 
      displayName: '', 
      category: 'String', 
      description: '', 
      template: '', 
      parameters: [] 
    };
  }

  /**
   * Opens the form to edit an existing function.
   */
  editFunction(index: number): void {
    const func = this.expressionFunctionsConfig.functions[index];
    if (func) {
      this.editingFunctionIndex = index;
      this.isAddingFunction = false;
      this.editingFunction = JSON.parse(JSON.stringify(func)); // Deep copy
    }
  }

  /**
   * Cancels the current function edit/add operation.
   */
  cancelFunctionEdit(): void {
    this.editingFunctionIndex = null;
    this.isAddingFunction = false;
    this.editingFunction = { name: '', displayName: '', category: 'String', description: '', template: '', parameters: [] };
  }

  /**
   * Saves the current function being edited/added.
   */
  saveFunction(): void {
    if (!this.editingFunction.name || !this.editingFunction.displayName) {
      this.toastr.error('Function name and display name are required', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }

    if (!this.expressionFunctionsConfig) {
      this.expressionFunctionsConfig = { functions: [], dateFormats: [], routeDetails: [], headerDetails: [], messageBodyDetails: [] };
    }

    if (!this.expressionFunctionsConfig.functions) {
      this.expressionFunctionsConfig.functions = [];
    }

    if (this.editingFunctionIndex !== null) {
      // Update existing function
      this.expressionFunctionsConfig.functions[this.editingFunctionIndex] = { ...this.editingFunction };
    } else {
      // Add new function
      this.expressionFunctionsConfig.functions.push({ ...this.editingFunction });
    }

    this.hasUnsavedFunctionChanges = true;
    this.cancelFunctionEdit();
    
    this.toastr.success('Function updated locally. Click "Save All Changes" to persist.', '', {
      positionClass: 'toast-bottom-right',
      timeOut: 2000,
    });
  }

  /**
   * Saves all function changes to the backend.
   */
  saveAllFunctions(): void {
    if (!this.expressionFunctionsConfig) {
      this.toastr.error('No configuration to save', '', {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      });
      return;
    }

    this.commonService.saveHL7ExpressionFunctions(this.expressionFunctionsConfig).subscribe({
      next: (response: any) => {
        if (response?.success) {
          this.hasUnsavedFunctionChanges = false;
          this.toastr.success('Expression functions saved successfully', '', {
            positionClass: 'toast-bottom-right',
            timeOut: 2000,
          });
          // Reload to ensure we have the latest
          this.expressionFunctionsLoaded = false;
          this.loadExpressionFunctions();
        } else {
          this.toastr.error(response?.message || 'Failed to save functions', '', {
            positionClass: 'toast-bottom-right',
            timeOut: 3000,
          });
        }
      },
      error: (err: any) => {
        console.error('Error saving expression functions', err);
        this.toastr.error('Error saving expression functions', '', {
          positionClass: 'toast-bottom-right',
          timeOut: 3000,
        });
      }
    });
  }

}



